<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="12"
            >
              <v-form ref="form_all">
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-receipt
                    </v-icon>Общие данные
                  </v-tab>
                  <v-tab v-if="form.type==ConfigurationTypeEnum.YandexCarWash">
                    <v-icon left>
                      mdi-car-wash
                    </v-icon>Боксы
                  </v-tab>
                  <v-tab v-if="form.type==ConfigurationTypeEnum.YandexCarWash">
                    <v-icon left>
                      mdi-receipt-outline
                    </v-icon>Список цен
                  </v-tab>
                  <v-tab v-if="form.type === 0 || form.type == 4 || form.type == 6 || form.type == 7 || form.type == 9 || form.type === ConfigurationTypeEnum.Skud">
                    <v-icon left>
                      mdi-dots-grid
                    </v-icon>Планограмма
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-tune
                    </v-icon>Настройки
                  </v-tab>
                  <v-tab v-if="form.type === 0 || form.type == 1 || form.type == 4 || form.type == 5 || form.type == 6 || form.type == 7 || form.type == 8 || form.type == 9 || form.type == 10 || form.type === ConfigurationTypeEnum.Skud">
                    <v-icon left>
                      mdi-tune
                    </v-icon>Интерфейс
                  </v-tab>
                  <v-tab v-if="form.type == 6 || form.type == 8 || form.type == 9 || form.type == 10 || form.type === ConfigurationTypeEnum.Skud">
                    Настройка шагов
                  </v-tab>
                  <!--                  <v-tab></v-tab>-->
                  <!-- tab items -->
                  <v-tab-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.updated"
                          label="Дата версиии"
                          type="date"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.version"
                          label="Версия"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.state"
                          label="Статус"
                          :items="select.state"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-select
                          v-model="form.type"
                          label="Тип конфигурации"
                          :items="select.type"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.name"
                          label="Название"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.description"
                          label="Описание"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-if="form.type == 5"
                        cols="8"
                      >
                        <v-select
                          v-model="form.integration"
                          :items="select.integration.filter(a=>a.type == 2)"
                          item-text="description"
                          item-value="id"
                          label="Интеграция"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="12"
                        xl="6"
                      >
                        <v-autocomplete
                          v-if="$store.state.access[28][5]"
                          v-model="form.client"
                          clearable
                          :filter="client_filter"
                          :items="select.clients"
                          item-value="id"
                          label="Наименование клиента"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.YandexCarWash">
                      <v-col cols="12">
                        <v-select
                          v-model="form.carWash.carWashType"
                          label="Тип мойки"
                          :items="select.carWashBoxTypeList"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.YandexCarWash">
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.carWash.stepCost"
                          type="number"
                          label="Шаг платежа"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.carWash.limitMinCost"
                          type="number"
                          label="Минимальный платеж"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.carWash.limitMaxCost"
                          type="number"
                          label="Максимальный платеж"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.YandexCarWash">
                      <v-col cols="12">
                        <v-checkbox
                          v-model="form.carWash.enable"
                          label="Работает"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.type===ConfigurationTypeEnum.YandexCarWash">
                    <v-row class="justify-center">
                      <v-col cols="12">
                        <v-data-table
                          :items="form.carWash.carWashBoxes"
                          :headers="yandexCarwashBoxHeaders"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.boxNumber="{item}">
                            <v-text-field
                              v-model="item.boxNumber"
                              type="number"
                              label="Номер бокса"
                              @change="onCarWashBoxAdd(item)"
                            />
                          </template>
                          <!--                          <template v-slot:item.carWashBoxType="{item}">-->
                          <!--                            <v-select-->
                          <!--                                v-model="item.carWashBoxType"-->
                          <!--                                label="Тип"-->
                          <!--                                :items="select.carWashBoxTypeList"-->
                          <!--                                @change="onCarWashBoxAdd(item)"-->
                          <!--                            />-->
                          <!--                          </template>-->
                          <template v-slot:item.carWashBoxStatus="{item}">
                            <v-select
                              v-model="item.carWashBoxStatus"
                              label="Тип"
                              :items="select.carWashBoxStatusList"
                              @change="onCarWashBoxAdd(item)"
                            />
                          </template>
                          <template v-slot:item.delete="{item}">
                            <v-icon
                              v-if="!item.new"
                              @click="form.carWash.carWashBoxes = form.carWash.carWashBoxes.filter(a=>a!=item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.type===ConfigurationTypeEnum.YandexCarWash">
                    <v-row class="justify-center">
                      <v-col cols="12">
                        <v-data-table
                          :items="form.carWash.carWashPrices"
                          :headers="yandexCarwashPriceHeaders"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.nomenclature="{item}">
                            <v-autocomplete
                              v-model="item.nomenclature"
                              :filter="nomenclature_filter"
                              :items="select.nomenclature.filter(a=>a.client == form.client)"
                              label="Поиск товара"
                              item-value="id"
                              item-text="name"
                              hide-no-data
                              @change="onCarWashPriceAdd(item), onCarWashNomenclatureSelect(item)"
                            />
                          </template>
                          <template v-slot:item.cost="{item}">
                            <v-text-field
                              v-model="item.cost"
                              type="number"
                              label="Цена"
                              @change="onCarWashPriceAdd(item)"
                            />
                          </template>
                          <template v-slot:item.costType="{item}">
                            <v-select
                              v-model="item.costType"
                              label="Тип"
                              :items="select.carWashPriceTypeList"
                              @change="onCarWashPriceAdd(item)"
                            />
                          </template>
                          <template v-slot:item.delete="{item}">
                            <v-icon
                              v-if="!item.new"
                              @click="form.carWash.carWashPrices = form.carWash.carWashPrices.filter(a=>a!=item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.type === 0 || form.type == 4 || form.type == 6 || form.type == 7 || form.type == 9 || form.type === ConfigurationTypeEnum.Skud ">
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-data-table
                          :items="form.planogramm"
                          :headers="planogramm_headers"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.price_cash="{item}">
                            <v-text-field
                              v-model="item.price_cash"
                              type="number"
                              label="Стоимость (наличные)"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.price_cashless="{item}">
                            <v-text-field
                              v-model="item.price_cashless"
                              type="number"
                              label="Стоимость (безналичные)"
                              @change="planogramm_change(item)"
                            />
                          </template>

                          <template v-slot:item.group_number="{item}">
                            <v-text-field
                              v-model="item.group_number"
                              type="number"
                              label="Номер колонки"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.number="{item}">
                            <v-text-field
                              v-model="item.number"
                              type="number"
                              :label="form.type == 7 ? 'Номер пистолета' : 'Код ячейки'"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.amount="{item}">
                            <v-text-field
                              v-model="item.amount"
                              type="number"
                              :label="form.type == 6 || form.type == 9 || form.type === ConfigurationTypeEnum.Skud ? 'Количество': 'Емкость ячейки'"
                              :disabled="item.type == 4"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.type="{item}">
                            <v-select
                              v-model="item.type"
                              label="Тип"
                              :items="select.nomenclature_type"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.nomenclature="{item}">
                            <v-autocomplete
                              v-model="item.nomenclature"
                              :filter="nomenclature_filter"
                              :items="select.nomenclature.filter(a=>a.client == form.client)"
                              label="Поиск товара"
                              item-value="id"
                              item-text="name"
                              hide-no-data
                              @change="nomenclature_selected(item), planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.tax="{item}">
                            <v-select
                              v-if="isKyrgyzClient"
                              v-model="item.tax_kg"
                              label="Ставка НДС"
                              :items="select.tax_kg"
                              @change="planogramm_change(item)"
                            />
                            <v-select
                              v-else
                              v-model="item.tax"
                              label="Ставка НДС"
                              :items="select.tax"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.nsp_kg="{item}">
                            <v-select
                              v-model="item.nsp_kg"
                              label="НСП"
                              :items="select.nsp_kg"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.equipment="{item}">
                            <v-select
                              v-model="item.equipment"
                              label="Реле"
                              :items="select.equipments"
                            />
                          </template>
                          <template v-slot:item.scenario="{item}">
                            <v-select
                              v-model="item.scenario"
                              label="Сценарий"
                              :items="select.scenarios"
                            />
                          </template>
                          <template v-slot:item.descriptionType="{item}">
                            <v-select
                              v-model="item.descriptionType"
                              label="Тип описания"
                              :items="descriptionTypes"
                            />
                          </template>
                          <template v-slot:item.description="{item}">
                            <v-text-field
                              v-if="item.descriptionType===3"
                              v-model="item.description"
                              label="Описание"
                            />
                          </template>
                          <template v-slot:item.delete="{item}">
                            <v-icon
                              v-if="!item.new"
                              @click="form.planogramm = form.planogramm.filter(a=>a!=item);onDeleteButtonExt(item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.settings.server"
                          label="Сервер"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.settings.port"
                          label="Порт"
                          type="number"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === 1 || form.type === 8">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-select
                          v-model="form.start_type"
                          label="Режим запуска"
                          :items="[{
                                     value: 0,
                                     text: 'Приложение'
                                   },
                                   {
                                     value: 1,
                                     text: 'Служба'
                                   }]"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.Point || form.start_type == 1 || form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-select
                          v-model="form.service.protocol"
                          label="Протокол"
                          :items="[{
                                     value: 0,
                                     text: 'JustPay'
                                   },
                                   {
                                     value: 1,
                                     text: 'TTK2'
                                   },
                                   {
                                     value: 2,
                                     text: 'Jetinno'
                                   },
                                   {
                                     value: 3,
                                     text: 'Wizarpos'
                                   },
                                   {
                                     value: 4,
                                     text: 'MSB'
                                   }]"
                          @change="protocol_change"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-row v-if="form.service.protocol===4">
                          <v-col>
                            <v-select
                              v-model="form.msb.connection"
                              label="Способ подключения"
                              :items="[{text:'RS232',value:1},{text:'USB', value:2},{text:'Bluetooth',value:3}]"
                            />
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="form.msb.department"
                              type="number"
                            >
                              Отдел
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <v-select
                              v-model="form.msb.baudRate"
                              label="Baud rate"
                              :items="[{text:'0',value:0},{text:'9600',value:1},{text:'11500',value:2}]"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row v-if="form.service.protocol==2 && (form.type===ConfigurationTypeEnum.PosPoint || form.type===ConfigurationTypeEnum.PosPointRelay)">
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <v-text-field
                              v-model="form.jetinno.ipAddressDevice"
                              label="Адрес устройства (Jetinno)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <v-text-field
                              v-model="form.jetinno.ipAddressServer"
                              label="Адрес сервера (Jetinno)"
                            />
                          </v-col>
                          <v-col>
                            <v-select
                              v-model="form.jetinno.jetinnoScenarioPayment"
                              label="Сценарий оплаты (Jetinno)"
                              :items="select.jetinno_jetinnoScenarioPayment_list"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.service.port"
                          label="Порт для подключения"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.service.timeout"
                          label="Тайм-аут"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-checkbox
                          v-model="form.service.send_to_server"
                          label="Отправлять операции на сервер"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.Vending">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.mdb.enable"
                          label="Подключение MDB"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.mdb.enable">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-select
                          v-model="form.mdb.type"
                          label="Способ подключения"
                          :items="[{value: 0, text: 'MDB Slave'}]"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.mdb.credit"
                          label="Максимальная сумма кредита"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-select
                          v-model="form.mdb.decimal_points"
                          label="Десятичная точка"
                          :items="[{value: 0, text: 0}, {value: 1, text: 1}, {value: 2, text: 2}, {value: 3, text: 3}]"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.mdb.scale"
                          label="Коэффициент масштабирования"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.mdb.always_idle"
                          label="Режим Always IDLE"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-select
                          v-model="form.mdb.device"
                          label="Тип устройства"
                          :items="[{value: 0, text: 'Нестле'}, {value: 1, text: 'Уникум'}, {value: 2, text: 'Сахарная вата'}]"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.Vending && isUsbConfLoaded">
                      <v-col>
                        <v-checkbox
                          v-model="form.usbConf.enable"
                          label="Подключение USB"
                        />
                      </v-col>
                      <v-col v-if="form.usbConf.enable">
                        <v-text-field
                          v-model="form.usbConf.port"
                          type="number"
                          label="USB порт"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.type === ConfigurationTypeEnum.Vending && isWizarposLoaded">
                      <v-col>
                        <v-checkbox
                          v-model="form.wizarpos"
                          label="Подключение Wizarpos"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-select
                          v-model="form.mdb.price_type"
                          label="Тип цены"
                          :items="[{value: 0, text: 'Брать из номенклатуры'},{value: 1, text: 'Брать из настроек аппарата'}]"
                        />
                      </v-col>
                      <v-col
                        v-if="form.type===ConfigurationTypeEnum.Point"
                        cols="12"
                        md="6"
                      >
                        <v-select
                          v-model="form.common.nomenclatureByDefault"
                          label="Наименование номенклатуры (по умолчанию)"
                          :items="select.nomenclature.map(m=>{return {text:`${m.name} (номер: ${m.number})`, value:m.id}})"
                        />
                      </v-col>
                      <v-col
                        v-if="form.type===ConfigurationTypeEnum.Point"
                        cols="12"
                        md="6"
                      >
                        <v-checkbox
                          v-model="form.common.useByDefault"
                          label="Использовать значение по умолчанию"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="form.common.firstScreenType"
                          label="Тип первого экрана"
                          :items="ConfigurationFirstScreenTypeArray()"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="form.common.paymentMethodScreenType"
                          label="Тип экрана оплаты"
                          :items="ConfigurationPaymentMethodScreenTypeArray()"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.mdb.main_screen_timeout"
                          label="Таймаут главного экрана (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.mdb.item_screen_timeout"
                          label="Таймаут выбора товара (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.mdb.payment_success_timeout"
                          label="Таймаут показа чека (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.common.fiscal_timeout"
                          label="Таймаут ожидания фискализации (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="form.common.cardTimeout"
                          label="Таймаут оплаты по карте (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          v-model="form.common.sbpTimeout"
                          label="Таймаут оплаты по СБП (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col
                        v-if="form.type==7"
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.gas.fillingStopTimeout"
                          label="Таймаут ожидания остановки налива (сек)"
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="form.common.typeScreenMax"
                          label="Тип экрана при сканировании Цифрового ID MAX"
                          :items="[{value:0, text: 'Отображать QR-код и одновременно сканировать Цифровой ID'},{value:1,text:'Сканировать Цифровой ID на отдельном шаге'}]"
                        />
                      </v-col>
                      <v-col
                        v-if="form.type === ConfigurationTypeEnum.PosPointRelay"
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.common.repeatsRelay"
                          label="Повторить срабатывание реле, для каждой товарной позиции"
                        />
                      </v-col>
                      <v-col
                        v-if="form.type === ConfigurationTypeEnum.Rele || form.type === ConfigurationTypeEnum.Skud"
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.common.inputCellCode"
                          label="Вводить код ячейки"
                        />
                      </v-col>
                      <v-col
                        v-if="form.type===ConfigurationTypeEnum.Azs"
                        cols="12"
                        md="12"
                      >
                        <v-tooltip
                          top
                          color="success"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-select
                              v-model="form.azs.mode"
                              label="Режим работы с колонками"
                              :items="[{text: 'Последовательный', value:1},{text: 'Параллельный', value:2}]"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <span>Последовательный режим - оплата выполняется последовательно на разных колонках. Одновременная оплата и налив на разных колонках невозможен до завершения предыдущего налива.
                            Параллельный - возможна оплата и налив одновременно с наливом на другой колонке.</span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.common.fiscal_required"
                          label="Обязательность фискализации"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.common.fiscal_cash"
                          label="Фискализация наличных операций"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.common.fiscal_card"
                          label="Фискализация безналичных операций"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.type === ConfigurationTypeEnum.Vending || form.type == 1 || form.type == 4 || form.type == 5 || form.type == 6 || form.type == 7 || form.type === ConfigurationTypeEnum.PosPoint || form.type == 9 || form.type === ConfigurationTypeEnum.PosPointRelay || form.type === ConfigurationTypeEnum.Skud">
                    <v-expansion-panels>
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vending || form.type === 1 || form.type == 4 || form.type == 6 || form.type == 7 || form.type === ConfigurationTypeEnum.PosPoint || form.type == 9 || form.type === ConfigurationTypeEnum.PosPointRelay || form.type === ConfigurationTypeEnum.Skud">
                        <v-expansion-panel-header>
                          Первый экран
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="4"
                              md="2"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.order"
                                label="Порядковый номер экрана"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="form.type == 7"
                          >
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-checkbox
                                v-model="form.gas.show_first_screen"
                                label="Отображать первый экран"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay"
                              cols="12"
                              md="12"
                            >
                              <v-checkbox
                                v-model="form.pos.show_menu"
                                label="Отображать меню"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="form.interface_description.first_screen.logo"
                                label="Логотип"
                                :btn_text="'Загрузить фотографию'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.logo_width"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.logo_height"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="form.interface_description.first_screen.logo_only"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="form.type === ConfigurationTypeEnum.Vending">
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="form.interface_description.first_screen.picture"
                                label="Картинка"
                                :btn_text="'Загрузить картинку'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.pictureWidth"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.pictureHeight"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="form.interface_description.first_screen.pictureOnly"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="form.type === ConfigurationTypeEnum.Vending">
                            <v-col>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <upload-media-files
                                    v-model="form.interface_description.first_screen.audio"
                                    audio
                                    label="Аудио"
                                  />
                                </v-col>
                                <v-col
                                  v-if="isAudioDataLoaded"
                                  cols="12"
                                  sm="2"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="form.interface_description.first_screen.audioData.timeout"
                                    type="number"
                                    label="Таймаут перед проигрыванием аудио (сек)"
                                  />
                                </v-col>
                                <v-col
                                  v-if="isAudioDataLoaded"
                                  cols="12"
                                  sm="2"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="form.interface_description.first_screen.audioData.duration"
                                    type="number"
                                    label="Длительность проигрывания аудио (сек)"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="2"
                                  md="2"
                                >
                                  <v-radio-group
                                    v-model="form.interface_description.first_screen.audioData.playEndless"
                                    mandatory
                                  >
                                    <v-radio
                                      label="Проигрывать один раз"
                                      :value="false"
                                    />
                                    <v-radio
                                      label="Проигрывать бесконечно"
                                      :value="true"
                                    />
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="8"
                                  md="6"
                                >
                                  <upload-media-files
                                    v-model="form.interface_description.first_screen.video1"
                                    label="Видео 1"
                                  />
                                </v-col>
                                <v-col
                                  v-if="isVideoData1Loaded"
                                  cols="12"
                                  sm="2"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="form.interface_description.first_screen.videoData1.timeout"
                                    type="number"
                                    label="Таймаут перед проигрыванием видео (сек)"
                                  />
                                </v-col>
                                <v-col
                                  v-if="isVideoData1Loaded"
                                  cols="12"
                                  sm="2"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="form.interface_description.first_screen.videoData1.duration"
                                    type="number"
                                    label="Длительность проигрывания видео (сек)"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="8"
                                  md="6"
                                >
                                  <upload-media-files
                                    v-model="form.interface_description.first_screen.video2"
                                    label="Видео 2"
                                  />
                                </v-col>
                                <v-col
                                  v-if="isVideoData2Loaded"
                                  cols="12"
                                  sm="2"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="form.interface_description.first_screen.videoData2.timeout"
                                    type="number"
                                    label="Таймаут перед проигрыванием видео (сек)"
                                  />
                                </v-col>
                                <v-col
                                  v-if="isVideoData2Loaded"
                                  cols="12"
                                  sm="2"
                                  md="3"
                                >
                                  <v-text-field
                                    v-model="form.interface_description.first_screen.videoData2.duration"
                                    type="number"
                                    label="Длительность проигрывания видео (сек)"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="form.type != 8"
                          >
                            <v-col cols="12">
                              Текст 1
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.text1.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.text1.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.first_screen.text1.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="form.type != 8"
                          >
                            <v-col cols="12">
                              Текст 2
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.text2.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.text2.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.first_screen.text2.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <strong>Кнопки</strong>
                            </v-col>
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.radius"
                                label="Размер радиуса"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type == 7"
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type != 8"
                              cols="12"
                              md="12"
                            >
                              <v-select
                                v-model="form.interface_description.first_screen.buttons.label_type"
                                label="Текст на кнопке"
                                :items="[
                                  {
                                    value: 0, text: 'Сумма'
                                  },
                                  {
                                    value: 1, text: 'Количество'
                                  },
                                  {
                                    value: 2, text: 'Описание'
                                  }
                                ]"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type != 8"
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                          <!-- begin busy button -->
                          <v-row>
                            <v-col cols="12">
                              <strong>Кнопки не активные</strong>
                            </v-col>
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons.radius"
                                label="Размер радиуса"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons_busy.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons_busy.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons_busy.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type == 7"
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons_busy.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type != 8"
                              cols="12"
                              md="12"
                            >
                              <v-select
                                v-model="form.interface_description.first_screen.buttons_busy.label_type"
                                label="Текст на кнопке"
                                :items="[
                                  {
                                    value: 0, text: 'Сумма'
                                  },
                                  {
                                    value: 1, text: 'Количество'
                                  },
                                  {
                                    value: 2, text: 'Описание'
                                  }]"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type != 8"
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.first_screen.buttons_busy.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                          <!-- end busy button -->

                          <!-- begin Extended buttons -->
                          <v-row
                            v-for="(buttonExt, index) in form.interface_description.first_screen.buttonsExt"
                            v-show="form.type===ConfigurationTypeEnum.Donation || form.type===ConfigurationTypeEnum.Rele || form.type===ConfigurationTypeEnum.Vitrina || form.type === ConfigurationTypeEnum.Skud"
                            :key="'bExt' + index"
                          >
                            <v-col cols="12">
                              <span class="blue--text text--lighten-2">
                                {{ "Номер ячейки " + buttonExt.cellCode }}
                              </span>
                            </v-col>
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="buttonExt.radius"
                                label="Размер радиуса"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="buttonExt.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="buttonExt.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="buttonExt.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type != 8"
                              cols="12"
                              md="12"
                            >
                              <v-select
                                v-model="buttonExt.label_type"
                                label="Текст на кнопке"
                                :items="[
                                  {
                                    value: 0, text: 'Сумма'
                                  },
                                  {
                                    value: 1, text: 'Количество'
                                  },
                                  {
                                    value: 2, text: 'Описание'
                                  }
                                ]"
                              />
                            </v-col>
                            <v-col
                              v-if="form.type != 8"
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="buttonExt.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                          <!-- end Extended buttons -->
                          <v-row
                            v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay"
                          >
                            <v-col cols="12">
                              <strong>Кнопки (Категории)</strong>
                            </v-col>
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="form.pos.category_buttons.radius"
                                label="Размер радиуса"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.pos.category_buttons.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.pos.category_buttons.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.pos.category_buttons.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <!-- <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.pos.category_buttons.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col> -->
                          </v-row>
                          <v-row
                            v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay"
                          >
                            <v-col cols="12">
                              <strong>Кнопки (Номенклатуры)</strong>
                            </v-col>
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="form.pos.nomenclature_buttons.radius"
                                label="Размер радиуса"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.pos.nomenclature_buttons.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.pos.nomenclature_buttons.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.pos.nomenclature_buttons.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.pos.nomenclature_buttons.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay"
                          >
                            <v-col cols="12">
                              <strong>Настройки штрихкода</strong>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="form.pos.barcode_settings.height"
                                label="Высота штрихкода"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="form.pos.barcode_settings.width"
                                label="Ширина штрихкода"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="form.pos.barcode_settings.angle"
                                label="Угол поворота штрихкода"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- Choose goods screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vending">
                        <v-expansion-panel-header>
                          Выбор товара на аппарате
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-firstscreen v-model="form.interface_description.chooseGoodsScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- Delivery of goods screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vending">
                        <v-expansion-panel-header>
                          Выдача товара
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-firstscreen v-model="form.interface_description.deliveryGoodsScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- second screen for type = 8 POS-point -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.PosPoint">
                        <v-expansion-panel-header>
                          Экран вызова пин-пада
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="4"
                              md="2"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.order"
                                label="Порядковый номер экрана"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-checkbox
                                v-model="form.pos.show_second_screen"
                                label="Отображать экран"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="form.interface_description.second_screen.logo"
                                label="Логотип"
                                :btn_text="'Загрузить фотографию'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.logo_width"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.logo_height"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="form.interface_description.second_screen.logo_only"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 1
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.text1.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.text1.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.second_screen.text1.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 2
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.text2.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.text2.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.second_screen.text2.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end second screen -->
                      <!-- third screen for type = 7 AZS -->
                      <v-expansion-panel v-if="form.type == 7">
                        <v-expansion-panel-header>
                          Экран для отправки чеков
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="4"
                              md="2"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.order"
                                label="Порядковый номер экрана"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-checkbox
                                v-model="form.pos.show_third_screen"
                                label="Отображать экран"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="form.interface_description.second_screen.logo"
                                label="Логотип"
                                :btn_text="'Загрузить фотографию'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.logo_width"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.logo_height"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="form.interface_description.second_screen.logo_only"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 1
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.text1.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.second_screen.text1.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.second_screen.text1.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12">
                              <strong>Кнопка</strong>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-select
                                v-model="form.interface_description.third_screen.buttons.label_type"
                                label="Текст на кнопке"
                                :items="[
                                  {
                                    value: 0, text: 'Сумма'
                                  },
                                  {
                                    value: 1, text: 'Количество'
                                  },
                                  {
                                    value: 2, text: 'Описание'
                                  }]"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <strong>Кнопка 2</strong>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons2.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons2.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons2.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons2.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-select
                                v-model="form.interface_description.third_screen.buttons2.label_type"
                                label="Текст на кнопке"
                                :items="[
                                  {
                                    value: 0, text: 'Сумма'
                                  },
                                  {
                                    value: 1, text: 'Количество'
                                  },
                                  {
                                    value: 2, text: 'Описание'
                                  }]"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons2.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                          <!-- begin busy button -->
                          <v-row>
                            <v-col cols="12">
                              <strong>Кнопка не акивная</strong>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons_busy.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons_busy.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons_busy.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons_busy.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-select
                                v-model="form.interface_description.third_screen.buttons_busy.label_type"
                                label="Текст на кнопке"
                                :items="[
                                  {
                                    value: 0, text: 'Сумма'
                                  },
                                  {
                                    value: 1, text: 'Количество'
                                  },
                                  {
                                    value: 2, text: 'Описание'
                                  }]"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.third_screen.buttons_busy.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                          <!-- end busy button -->
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end third screen  -->
                      <!-- fourth screen for type = 7 AZS -->
                      <v-expansion-panel v-if="form.type == 7">
                        <v-expansion-panel-header>
                          Настройки для кнопок
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="4"
                              md="2"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.order"
                                label="Порядковый номер экрана"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-checkbox
                                v-model="form.interface_description.fourth_screen.show_full_tank"
                                label="Режим полного бака"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>

                            <v-col cols="12">
                              Сумма полного бака
                            </v-col>

                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.sum_full_tank"
                                label="Сумма полного бака"
                              />
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12">
                              <strong>Кнопка</strong>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.buttons.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.buttons.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.buttons.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.buttons.stroke"
                                label="Дополнительный цвет кнопок"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="form.interface_description.fourth_screen.buttons.label"
                                label="Текст кнопки для свободного ввода"
                              />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end fourth screen  -->
                      <!-- PaymentMethod screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vitrina ">
                        <v-expansion-panel-header>
                          Экран выбора способа оплаты
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-payment-method-screen v-model="form.interface_description.paymentMethodScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end PaymentMethod screen -->
                      <!-- Universal screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vitrina ">
                        <v-expansion-panel-header>
                          Универсальный экран
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-universal-screen v-model="form.interface_description.universalScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end Universal screen -->
                      <!-- Staff screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vitrina ">
                        <v-expansion-panel-header>
                          Экран чтение карты доступа
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-staff-screen v-model="form.interface_description.staffScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end staff screen -->
                      <!-- StaffPayment screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.Vitrina ">
                        <v-expansion-panel-header>
                          Экран чтение карты доступа + оплата
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-staff-payment-screen v-model="form.interface_description.staffPaymentScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end staffPayment screen -->
                      <!-- PosPont Bucket Screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay ">
                        <v-expansion-panel-header>
                          Экран настройки корзины
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-pospoint-bucket-screen v-model="form.posPointScreen.posPointBucketScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end PosPont Bucket Screen -->
                      <!-- PosPont Choose Goods Screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay ">
                        <v-expansion-panel-header>
                          Экран выбора товара
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-pospoint-choose-goods-screen v-model="form.posPointScreen.posPointChooseGoodsScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end PosPont Choose Goods Screen -->
                      <!-- PosPont Choose Payment Screen -->
                      <v-expansion-panel v-if="form.type === ConfigurationTypeEnum.PosPoint || form.type === ConfigurationTypeEnum.PosPointRelay ">
                        <v-expansion-panel-header>
                          Экран выбора способа оплаты
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <setup-pospoint-choose-payment-screen v-model="form.posPointScreen.posPointChoosePaymentScreen" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- end PosPont Choose Payment Screen -->
                      <!-- error screen -->
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Экран ошибки
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="4"
                              md="2"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.order"
                                label="Порядковый номер экрана"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="form.interface_description.error_screen.logo"
                                label="Логотип"
                                :btn_text="'Загрузить фотографию'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.logo_width"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.logo_height"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="form.interface_description.error_screen.logo_only"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 1
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.text1.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.text1.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.error_screen.text1.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 2
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.text2.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.error_screen.text2.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.error_screen.text2.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="form.type === ConfigurationTypeEnum.Vending">
                            <v-col>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="8"
                                  md="6"
                                >
                                  <upload-media-files
                                    v-model="form.interface_description.error_screen.audio"
                                    audio
                                    label="Аудио"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!-- Final screen -->
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Последний экран
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="4"
                              md="2"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.order"
                                label="Порядковый номер экрана"
                                type="number"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="form.interface_description.final_screen.logo"
                                label="Логотип"
                                :btn_text="'Загрузить фотографию'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.logo_width"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.logo_height"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="form.interface_description.final_screen.logo_only"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-checkbox
                                v-model="form.interface_description.final_screen.show_qr"
                                label="Отображать QR"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 1
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.text1.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.text1.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.final_screen.text1.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 2
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.text2.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.text2.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.final_screen.text2.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 3
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.text3.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="form.interface_description.final_screen.text3.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="form.interface_description.final_screen.text3.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                          </v-row>
                          <v-row v-if="form.type === ConfigurationTypeEnum.Vending">
                            <v-col>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="8"
                                  md="6"
                                >
                                  <upload-media-files
                                    v-model="form.interface_description.final_screen.audio"
                                    audio
                                    label="Аудио"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel
                        v-for="(scenario, idx) in form.releScenarios"
                        v-show="form.type == 6 || form.type == 9 || form.type === ConfigurationTypeEnum.PosPointRelay || form.type === ConfigurationTypeEnum.Skud"
                        :key="idx"
                      >
                        <v-expansion-panel-header>
                          Реле {{ scenario.scenarioName }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row
                            v-for="(item,index) in scenario.releConf.pages"
                            :key="index"
                          >
                            <v-col cols="8">
                              Страница (шаг) {{ index + 1 }}
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.background"
                                label="Цвет фона"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.toolbar"
                                label="Цвет тулбара"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <uploadFiles
                                v-model="item.screen.logo"
                                label="Логотип"
                                :btn_text="'Загрузить фотографию'"
                                :limit="1"
                                :single="true"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="item.screen.logo_width"
                                label="Ширина изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-text-field
                                v-model="item.screen.logo_height"
                                label="Высота изображения"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                            >
                              <v-checkbox
                                v-model="item.screen.logo_only"
                                label="Изображение - во весь экран"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 1
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.text1.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.text1.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="item.screen.text1.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              Текст 2
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.text2.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.text2.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-textarea
                                v-model="item.screen.text2.text"
                                label="Текст"
                                type="text"
                              />
                            </v-col>
                            <v-col cols="12">
                              Кнопки
                            </v-col>
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="item.screen.buttons.radius"
                                type="number"
                                label="Размер радиуса"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.buttons.text.text"
                                label="Текст"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.buttons.text.size"
                                label="Размер шрифта"
                                type="number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.screen.buttons.text.color"
                                label="Цвет шрифта"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="item.screen.buttons.background"
                                label="Цвет фона"
                              />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card v-if="form.type == 8 || form.type == 10">
                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <v-expansion-panels>
                              <v-expansion-panel
                                v-for="(page, index) in form.pos.pages"
                                :key="'pos_' + index"
                              >
                                <v-expansion-panel-header>
                                  <div class="d-flex flex-row align-center">
                                    Шаг&nbsp;{{ index + 1 }}<span
                                      v-if="page.type != null"
                                      style="color: gray"
                                    >&nbsp;{{ dict.pos_page_types[page.type] }}</span>
                                    <div class="ml-4">
                                      <v-icon
                                        color="#aaaaaa"
                                        class="mr-2"
                                        style="cursor: pointer;"
                                        @click="form.pos.pages = form.pos.pages.filter((a, i) => i != index)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </div>
                                  </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <!-- <v-row class="mb-10">
                            <span
                              style="cursor: pointer"
                              @click="form.pos.pages = form.pos.pages.filter(a=>a != page)"
                            >Удалить страницу</span>
                          </v-row> -->
                                  <v-row class="mb-10">
                                    <v-col cols="4">
                                      <v-select
                                        v-model="page.type"
                                        :items="[
                                          { value: 0, text: 'Ввод данных'},
                                          { value: 1, text: 'Информация'},
                                          { value: 2, text: 'Каталог'},
                                          { value: 3, text: 'Корзина'},
                                        ]"
                                        label="Тип шага"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    v-if="page.type == 0"
                                    class="mb-10"
                                  >
                                    <v-col cols="4">
                                      <v-text-field
                                        v-model="page.field_name"
                                        label="Название поля"
                                      />
                                    </v-col>
                                    <v-col cols="4">
                                      <v-select
                                        v-model="page.action_type"
                                        :items="[
                                          { value: 0, text: 'Сохранить в коллекцию платежа'},
                                          { value: 1, text: 'Интеграция'},
                                          { value: 2, text: 'Интеграция из номенклатуры'}
                                        ]"
                                        label="Действие"
                                        clearable
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="page.action_type == 1"
                                      cols="4"
                                    >
                                      <v-select
                                        v-model="page.integration"
                                        :items="select.integration_list.filter(a => a.type == 3)"
                                        label="Список интеграций"
                                        clearable
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    v-if="page.type == 0"
                                    class="mb-10"
                                  >
                                    <v-col
                                      cols="10"
                                      md="5"
                                    >
                                      <v-text-field
                                        v-model="page.temp_skip_codes"
                                        class="notranslate"
                                        label="Пропускаем для артикулов (введите номера через запятую или пробел и подтвердите)"
                                        underlined
                                        @keyup.enter="skip_codes_save(page)"
                                      />
                                    </v-col>
                                    <v-col
                                      cols="2"
                                      md="1"
                                      class="text-center"
                                    >
                                      <v-btn
                                        text
                                        color="primary"
                                        class="mt-3"
                                        @click="skip_codes_save(page)"
                                      >
                                        <v-icon
                                          large
                                          color="primary"
                                          class="mr-2"
                                        >
                                          mdi-plus-circle-outline
                                        </v-icon>
                                        Добавить
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-chip
                                        v-for="(tag, tag_index) in page.skip_codes"
                                        :key="'t_' + tag_index"
                                        class="ma-2 px-5 ds-chip"
                                        color="#6897c0"
                                        label
                                        dark
                                      >
                                        {{ tag }}
                                        <v-icon
                                          small
                                          color="#333333"
                                          style="cursor:pointer"
                                          class="ml-4"
                                          @click="page.skip_codes = page.skip_codes.filter((a, i) => i != tag_index); $forceUpdate();"
                                        >
                                          mdi-delete
                                        </v-icon>
                                      </v-chip>
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    v-if="page.type == 1"
                                    class="mb-10"
                                  >
                                    <div class="mr-3 ml-3">
                                      <div>
                                        <strong>Экран</strong>
                                      </div>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                          md="12"
                                        >
                                          <v-text-field
                                            v-model="page.screen.background"
                                            label="Цвет фона"
                                          />
                                        </v-col>
                                        <!-- <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="page.screen.toolbar"
                                    label="Цвет тулбара"
                                  />
                                </v-col> -->
                                        <v-col cols="12">
                                          <strong>Текст 1</strong>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="6"
                                        >
                                          <v-text-field
                                            v-model="page.screen.text1.size"
                                            label="Размер шрифта"
                                            type="number"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="6"
                                        >
                                          <v-text-field
                                            v-model="page.screen.text1.color"
                                            label="Цвет шрифта"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="12"
                                        >
                                          <v-textarea
                                            v-model="page.screen.text1.text"
                                            label="Текст"
                                            type="text"
                                          />
                                        </v-col>
                                        <v-col cols="12">
                                          <strong>Изображение</strong>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="3"
                                        >
                                          <uploadFiles
                                            v-model="page.screen.logo"
                                            label="Изображение"
                                            :btn_text="'Загрузить изображение'"
                                            :limit="1"
                                            :single="true"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="3"
                                        >
                                          <v-text-field
                                            v-model="page.screen.logo_width"
                                            label="Ширина изображения"
                                            type="number"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="3"
                                        >
                                          <v-text-field
                                            v-model="page.screen.logo_height"
                                            label="Высота изображения"
                                            type="number"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="3"
                                        >
                                          <v-checkbox
                                            v-model="page.screen.logo_only"
                                            label="Изображение - во весь экран"
                                          />
                                        </v-col>

                                        <v-col cols="12">
                                          <strong>Текст 2</strong>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="6"
                                        >
                                          <v-text-field
                                            v-model="page.screen.text2.size"
                                            label="Размер шрифта"
                                            type="number"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="6"
                                        >
                                          <v-text-field
                                            v-model="page.screen.text2.color"
                                            label="Цвет шрифта"
                                          />
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          md="12"
                                        >
                                          <v-textarea
                                            v-model="page.screen.text2.text"
                                            label="Текст"
                                            type="text"
                                          />
                                        </v-col>
                                        <!-- <v-col cols="12">
                                  Кнопки
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="page.screen.buttons.text.size"
                                    label="Размер шрифта"
                                    type="number"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="page.screen.buttons.text.color"
                                    label="Цвет шрифта"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="12"
                                >
                                  <v-text-field
                                    v-model="page.screen.buttons.background"
                                    label="Цвет фона"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="12"
                                >
                                  <v-select
                                    v-model="page.screen.buttons.label_type"
                                    label="Текст на кнопке"
                                    :items="[
                                      {
                                        value: 0, text: 'Сумма'
                                      },
                                      {
                                        value: 1, text: 'Количество'
                                      }]"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="12"
                                >
                                  <v-text-field
                                    v-model="page.screen.buttons.label"
                                    label="Текст кнопки для свободного ввода"
                                  />
                                </v-col> -->
                                      </v-row>
                                    </div>
                                  </v-row>
                                  <div
                                    v-if="page.type == 2"
                                    class="mb-10"
                                  >
                                    <div>
                                      <strong>Свободная цена</strong>
                                    </div>
                                    <v-row>
                                      <v-col
                                        cols="12"
                                        md="4"
                                      >
                                        <v-checkbox
                                          v-model="page.open_price.enable"
                                          label="Свободная цена"
                                        />
                                      </v-col>
                                      <v-col
                                        v-show="page.open_price.enable"
                                        cols="12"
                                        md="4"
                                      >
                                        <v-text-field
                                          v-model="page.open_price.name"
                                          label="Название товара (то, что будет попадать в корзину)"
                                        />
                                      </v-col>
                                      <v-col
                                        v-show="page.open_price.enable"
                                        cols="12"
                                        md="4"
                                      >
                                        <v-text-field
                                          v-model="page.open_price.label"
                                          label="Текстовка кнопки - то, что на кнопке"
                                        />
                                      </v-col>
                                      <v-col
                                        v-show="page.open_price.enable"
                                        cols="12"
                                        md="4"
                                      >
                                        <template v-if="isKyrgyzClient">
                                          <v-select
                                            v-model="page.open_price.tax_kg"
                                            label="НДС"
                                            :items="select.tax_kg"
                                          />
                                          <v-select
                                            v-model="page.open_price.nsp_kg"
                                            label="НСП"
                                            :items="select.nsp_kg"
                                          />
                                        </template>
                                        <v-select
                                          v-else
                                          v-model="page.open_price.tax"
                                          label="НДС"
                                          :items="select.tax"
                                        />
                                      </v-col>
                                    </v-row>
                                    <div>
                                      <strong>Номенклатуры</strong>
                                    </div>
                                    <v-row>
                                      <v-col cols="4">
                                        <v-btn
                                          color="primary"
                                          large
                                          min-width="100"
                                          class="mr-5"
                                          @click="() => show_pos_catalog_dialog(page)"
                                        >
                                          Добавить
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="8" />
                                      <!-- <v-col cols="4">
                                <v-select
                                  v-model="page.category"
                                  :items="select.categories_list"
                                  label="Категория"
                                  @change="() =>{ page.subcategory = null; page.subsubcategory = null; }"
                                />
                              </v-col>
                              <v-col
                                v-if="page.category != null && select.categories"
                                cols="4"
                              >
                                <v-select
                                  v-model="page.subcategory"
                                  :items="select.categories.filter(a => a.category == page.category).map(b => ({value: b.id, text: b.name}))"
                                  label="Подкатегория"
                                  @change="() =>{ page.subsubcategory = null }"
                                />
                              </v-col>
                              <v-col
                                v-if="page.subcategory != null && select.categories"
                                cols="4"
                              >
                                <v-select
                                  v-model="page.subsubcategory"
                                  :items="select.categories.filter(a => a.category == page.subcategory).map(b => ({value: b.id, text: b.name}))"
                                  label="Подподкатегория"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                v-if="select.nomenclature"
                                cols="4"
                              >
                                <v-select
                                  v-model="page.nomenclature_list"
                                  :items="select.nomenclature.filter(a => (
                                    (page.category ? a.category == page.category : true) &&
                                    (page.subcategory ? a.subcategory == page.subcategory: true) &&
                                    (page.subsubcategory ? a.subsubcategory == page.subsubcategory: true)
                                  )
                                  ).map(b => ({value: b.id, text: b.name}))"
                                  label="Товар"
                                  multiple
                                />
                              </v-col>
                              <v-col cols="4">
                                <v-btn
                                  color="primary"
                                  large
                                  min-width="100"
                                  class="mr-5"
                                  @click="() => add_nomenclature(page)"
                                >
                                  Добавить
                                </v-btn>
                              </v-col> -->
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12">
                                        <div
                                          style="display: flex; flex-direction: row; cursor: pointer;"
                                          class="ml-2 mb-3"
                                          @click="delete_selected_nomenclatures(page)"
                                        >
                                          <div>
                                            <v-icon
                                              medium
                                              color="#aaaaaa"
                                              class="mr-1"
                                            >
                                              mdi-delete
                                            </v-icon>
                                          </div>
                                          <div style="color: #aaaaaa">
                                            Убрать выбранные из таблицы
                                          </div>
                                        </div>
                                        <v-data-table
                                          v-model="page.selected_nomenclature"
                                          :items-per-page="10"
                                          dense
                                          :items="page.nomenclatures"
                                          :headers="pos_nomenclature_headers"
                                          :footer-props="datatable_footer"
                                          no-data-text="Нет данных для отображения"
                                          show-select
                                        >
                                          <template v-slot:item.type="{item}">
                                            <v-select
                                              v-model="item.type"
                                              label="Тип"
                                              :items="select.nomenclature_type"
                                            />
                                          </template>
                                          <template v-slot:item.tax="{item}">
                                            <v-select
                                              v-if="isKyrgyzClient"
                                              v-model="item.tax_kg"
                                              label="Ставка НДС"
                                              :items="select.tax_kg"
                                            />
                                            <v-select
                                              v-else
                                              v-model="item.tax"
                                              label="Ставка НДС"
                                              :items="select.tax"
                                            />
                                          </template>
                                          <template v-slot:item.nsp_kg="{item}">
                                            <v-select
                                              v-model="item.nsp_kg"
                                              label="НСП"
                                              :items="select.nsp_kg"
                                            />
                                          </template>
                                          <template v-slot:item.next_on_choose="{ item }">
                                            <v-checkbox
                                              v-model="item.next_on_choose"
                                              label="Переход на следующий шаг при выборе"
                                            />
                                          </template>
                                          <template v-slot:item.integration="{ item }">
                                            <v-select
                                              v-model="item.integration_item"
                                              :items="select.integration.filter(a => a.type == 3)"
                                              item-text="description"
                                              item-value="id"
                                              label="Интеграция"
                                              clearable
                                            />
                                          </template>
                                          <template v-slot:item.delete="{ item }">
                                            <v-icon
                                              color="#aaaaaa"
                                              class="mr-2"
                                              style="cursor: pointer;"
                                              @click="delete_nomenclature(page, item, $event)"
                                            >
                                              mdi-delete
                                            </v-icon>
                                          </template>
                                          <template v-slot:item.category="{item}">
                                            <div>
                                              <div v-if="page.category && dict.categories[page.category]">
                                                {{ dict.categories[page.category] }}
                                              </div>
                                              <div v-else>
                                                <span style="color: #EEEEEE">нет</span>
                                              </div>
                                            </div>
                                          </template>
                                          <template v-slot:item.subcategory="{item}">
                                            <div>
                                              <div v-if="page.subcategory && dict.categories[page.subcategory]">
                                                {{ dict.categories[page.subcategory] }}
                                              </div>
                                              <div v-else>
                                                <span style="color: #EEEEEE">нет</span>
                                              </div>
                                            </div>
                                          </template>
                                          <template v-slot:item.subsubcategory="{item}">
                                            <div>
                                              <div v-if="page.subsubcategory && dict.categories[page.subsubcategory]">
                                                {{ dict.categories[page.subsubcategory] }}
                                              </div>
                                              <div v-else>
                                                <span style="color: #EEEEEE">нет</span>
                                              </div>
                                            </div>
                                          </template>
                                          <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
                                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                                          </template>
                                          <template v-slot:item.cellCode="{item}">
                                            <v-text-field
                                              v-model="item.cellCode"
                                              label="Код ячейки"
                                              type="number"
                                            />
                                          </template>
                                          <template v-slot:item.relayNumber="{item}">
                                            <v-select
                                              v-model="item.relayNumber"
                                              label="Номер реле"
                                              :items="point ? point.equipments.filter(f=>f.type === 6).map(m=>m.serial): []"
                                            />
                                          </template>
                                          <template v-slot:item.scenario="{item}">
                                            <v-select
                                              v-model="item.scenario"
                                              label="Сценарий"
                                              :items="select.scenarios"
                                            />
                                          </template>
                                          <template v-slot:item.equipment="{item}">
                                            <v-select
                                              v-model="item.equipment"
                                              label="Оборудование"
                                              :items="select.equipmentsCatalog"
                                            />
                                          </template>
                                        </v-data-table>
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <div
                                    v-if="page.type == 3"
                                    class="mb-10"
                                  >
                                    <div>
                                      <strong>Настройка кнопок</strong>
                                    </div>
                                    <v-expansion-panels class="mt-3">
                                      <v-expansion-panel
                                        v-for="(btn, btn_index) in page.cart.buttons"
                                        :key="'p_' + index + '_btn_' + btn_index"
                                      >
                                        <v-expansion-panel-header>
                                          <div class="d-flex flex-row align-center">
                                            Кнопка&nbsp;{{ btn_index + 1 }}<span
                                              v-if="btn.name != null && btn.name.text"
                                              style="color: gray"
                                            >&nbsp;{{ btn.name.text }}</span>
                                            <div class="ml-4">
                                              <v-icon
                                                color="#aaaaaa"
                                                class="mr-2"
                                                style="cursor: pointer;"
                                                @click="page.cart.buttons = page.cart.buttons.filter((a, i) => i != btn_index); $forceUpdate();"
                                              >
                                                mdi-delete
                                              </v-icon>
                                            </div>
                                          </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-row>
                                            <v-col cols="12">
                                              <strong>Название</strong>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="6"
                                            >
                                              <v-text-field
                                                v-model="btn.name.size"
                                                label="Размер шрифта"
                                                type="number"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="6"
                                            >
                                              <v-text-field
                                                v-model="btn.name.color"
                                                label="Цвет шрифта"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="12"
                                            >
                                              <v-text-field
                                                v-model="btn.name.text"
                                                label="Текст"
                                                type="text"
                                              />
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="12">
                                              <strong>Изображение</strong>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                            >
                                              <uploadFiles
                                                v-model="btn.logo"
                                                label="Изображение"
                                                :btn_text="'Загрузить изображение'"
                                                :limit="1"
                                                :single="true"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                            >
                                              <v-text-field
                                                v-model="btn.logo_width"
                                                label="Ширина изображения"
                                                type="number"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                            >
                                              <v-text-field
                                                v-model="btn.logo_height"
                                                label="Высота изображения"
                                                type="number"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                            >
                                              <v-checkbox
                                                v-model="btn.logo_only"
                                                label="Изображение - во весь экран"
                                              />
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="12">
                                              <strong>Общие настройки</strong>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="6"
                                            >
                                              <v-select
                                                v-model="btn.integration"
                                                :items="select.integration.filter(a => a.type == 3)"
                                                item-text="description"
                                                item-value="id"
                                                label="Интеграция"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="6"
                                            >
                                              <v-text-field
                                                v-model="btn.background"
                                                label="Цвет фона"
                                              />
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="12"
                                            >
                                              <v-checkbox
                                                v-model="btn.scan"
                                                label="Сканировать штрихкод "
                                              />
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                    <v-row class="justify-start">
                                      <v-col
                                        cols="12"
                                        class="text-start"
                                        lg="12"
                                        xl="6"
                                      >
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="add_new_pos_cart_button(page); $forceUpdate();"
                                        >
                                          <v-icon
                                            large
                                            class="mr-2"
                                            color="primary"
                                          >
                                            mdi-plus-circle-outline
                                          </v-icon>
                                          Добавить новую кнопку
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-row

                          class="justify-center"
                        >
                          <v-col
                            cols="12"
                            class="text-center"
                            lg="12"
                            xl="6"
                          >
                            <v-btn
                              text
                              color="primary"
                              @click="add_new_pos_page(); $forceUpdate();"
                            >
                              <v-icon
                                large
                                class="mr-2"
                                color="primary"
                              >
                                mdi-plus-circle-outline
                              </v-icon>
                              Добавить новую POS страницу
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                    <v-card
                      v-for="(scenario, idx) in form.releScenarios"
                      v-if="form.type == 6 || form.type == 9 || form.type==10 || form.type === ConfigurationTypeEnum.Skud"
                      :key="idx"
                      class="mb-4"
                    >
                      <v-card-title v-if="form.type == 9 || form.type == 10 || form.type === ConfigurationTypeEnum.Skud">
                        <v-row>
                          <v-col
                            cols="10"
                            sm="11"
                          >
                            <v-text-field v-model="scenario.scenarioName" />
                          </v-col>
                          <v-col
                            cols="2"
                            sm="1"
                            class="d-flex align-center"
                          >
                            <v-btn
                              icon
                              @click="onDialogYesNoForDeletingScenario(idx)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-row v-if="form.type == ConfigurationTypeEnum.Vitrina || form.type == ConfigurationTypeEnum.Rele || form.type==ConfigurationTypeEnum.PosPointRelay || form.type === ConfigurationTypeEnum.Skud">
                          <v-col cols="12">
                            <v-expansion-panels>
                              <v-expansion-panel
                                v-for="(item,index) in scenario.releConf.pages"
                                :key="index"
                              >
                                <v-expansion-panel-header>
                                  <v-row>
                                    <v-col
                                      cols="2"
                                      class="d-flax align-content-center"
                                    >
                                      Страница (шаг) {{ index + 1 }}
                                    </v-col>
                                    <v-col v-if="item.executionRelay===1">
                                      Выполняется с условием: И
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-row class="mb-10">
                                    <v-col
                                      cols="2"
                                      class="d-flax align-content-center"
                                    >
                                      <span>Удалить страницу</span><v-icon @click="scenario.releConf.pages = scenario.releConf.pages.filter(page=>page!=item)">
                                        mdi-delete
                                      </v-icon>
                                    </v-col>
                                    <v-col
                                      cols="2"
                                      class="d-flex align-content-start"
                                    >
                                      <v-select
                                        v-model="item.executionRelay"
                                        dense
                                        label="Выполнение шага"
                                        :items="[{text:'-',value:0},{text:'И',value:1}]"
                                      />
                                    </v-col>
                                    <v-col cols="2">
                                      <v-select
                                        v-model="item.channel"
                                        dense
                                        label="Канал"
                                        :items="[{text:'TCP', value:1},{text:'Digital I/O', value:2}]"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-col cols="4">
                                    <v-text-field
                                      v-model="item.timeout"
                                      label="Таймаут шага (сек)"
                                      type="number"
                                    />
                                  </v-col>
                                  <v-col cols="4">
                                    <v-select
                                      v-model="item.timeout_action"
                                      :items="[
                                        { value: 0, text: 'Выход из сценария'},
                                        { value: 3, text: 'Переход к следующему действию'},
                                        { value: 4, text: 'Переход к следующему шагу'},
                                        { value: 5, text: 'Считать условие выполненным'}
                                      ]"
                                      label="Действие по таймауту"
                                    />
                                  </v-col>
                                  <v-row
                                    v-for="(action, index) in item.actions"
                                    :key="'1' + index"
                                  >
                                    <v-col cols="12">
                                      Действие {{ index + 1 }} <v-icon @click="item.actions = item.actions.filter(a=>a!=action)">
                                        mdi-delete
                                      </v-icon>
                                    </v-col>
                                    <v-col cols="12">
                                      Условие
                                    </v-col>

                                    <v-col cols="4">
                                      <v-text-field
                                        v-model="action.error_timeout"
                                        label="Таймаут при неуспешном выполнении условия (сек)"
                                        type="number"
                                      />
                                    </v-col>
                                    <v-col cols="4">
                                      <v-select
                                        v-model="action.error_action"
                                        :items="[
                                          { value: 0, text: 'Выход из сценария'},
                                          { value: 1, text: 'Повтор текущего действия'},
                                          { value: 2, text: 'Повтор текущего шага'},
                                          { value: 3, text: 'Переход к следующему действию'},
                                          { value: 4, text: 'Переход к следующему шагу'}
                                        ]"
                                        label="Действие при неуспешном условии"
                                      />
                                    </v-col>

                                    <v-col cols="4">
                                      <v-select
                                        v-model="action.command_type"
                                        :items="[
                                          { value: 0, text: 'Отсутствие команды'},
                                          { value: 1, text: 'Запрос на реле'},
                                          { value: 2, text: 'Показ главного экрана'}
                                        ]"
                                        label="Действие при успешном условии"
                                      />
                                    </v-col>
                                    <v-col cols="12">
                                      <condition v-model="action.condition" />
                                    </v-col>
                                    <v-col
                                      v-if="action.command_type == 1"
                                      cols="12"
                                    >
                                      <v-text-field
                                        v-model="action.before_timeout"
                                        label="Таймаут ДО выполнения команды (сек)"
                                        type="number"
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="action.command_type == 1"
                                      cols="12"
                                    >
                                      <v-text-field
                                        v-model="action.command.number"
                                        label="Номер реле (rele)"
                                        type="number"
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="action.command_type == 1"
                                      cols="12"
                                    >
                                      <v-text-field
                                        v-model="action.command.type"
                                        label="Тип команды (type)"
                                        type="number"
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="action.command_type == 1"
                                      cols="12"
                                    >
                                      <v-text-field
                                        v-model="action.command.value"
                                        label="Действие (on)"
                                        type="number"
                                      />
                                    </v-col>
                                    <v-col
                                      v-if="action.command_type == 1"
                                      cols="12"
                                    >
                                      <v-text-field
                                        v-model="action.command.time"
                                        label="Время импульса (time)"
                                        type="number"
                                      />
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="action.after_timeout"
                                        label="Таймаут ПОСЛЕ выполнения команды (сек)"
                                        type="number"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row class="justify-center">
                                    <v-col
                                      cols="12"
                                      class="text-center"
                                      lg="12"
                                      xl="6"
                                    >
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="add_new_action(item)"
                                      >
                                        <v-icon
                                          large
                                          class="mr-2"
                                          color="primary"
                                        >
                                          mdi-plus-circle-outline
                                        </v-icon>
                                        Добавить новое действие
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider />
                      <v-card-actions>
                        <v-row
                          v-if="form.type === ConfigurationTypeEnum.Vitrina || form.type === ConfigurationTypeEnum.Rele || form.type===ConfigurationTypeEnum.PosPointRelay || form.type === ConfigurationTypeEnum.Skud"
                          class="justify-center"
                        >
                          <v-col
                            cols="6"
                            class="text-center"
                            lg="6"
                            xl="6"
                          >
                            <v-btn
                              text
                              color="light-blue lighten-1"
                              @click="add_new_page(idx)"
                            >
                              <v-icon
                                large
                                class="mr-2"
                                color="light-blue lighten-1"
                              >
                                mdi-plus-circle-outline
                              </v-icon>
                              Добавить новую страницу
                            </v-btn>
                          </v-col>
                          <v-col
                            v-if="form.type === ConfigurationTypeEnum.Rele || form.type === ConfigurationTypeEnum.PosPointRelay || form.type === ConfigurationTypeEnum.Skud"
                            cols="6"
                            class="text-center"
                          >
                            <v-btn
                              text
                              color="light-green lighten-1"
                              @click="onCopyScenario(idx)"
                            >
                              <v-icon
                                large
                                class="mr-2"
                                color="light-green lighten-1"
                              >
                                mdi-shape-circle-plus
                              </v-icon>
                              Копировать сценарий
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                    <v-row v-if="form.type == 9 || form.type == 10 || form.type === ConfigurationTypeEnum.Skud">
                      <v-col class="text-center">
                        <v-btn
                          active-class="light-blue darken-3"
                          text
                          color="light-blue lighten-4"
                          @click="onDialogScenario"
                          @mouseover="onMouseOver"
                          @mouseout="onMouseOut"
                        >
                          <v-icon
                            large
                            class="mr-2"
                          >
                            mdi-playlist-plus
                          </v-icon>
                          Добавить новый сценарий
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="4"
              lg="2"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              cols="4"
              lg="2"
              class="text-center"
            >
              <v-btn
                v-if="!view"
                color="primary"
                class="ml-auto"
                @click="save(true)"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
            <v-col
              cols="4"
              lg="2"
              class="text-right"
            >
              <v-btn
                v-if="!view"
                color="blue darken-1 white--text"
                class="ml-auto"
                @click="save(false)"
              >
                <span class="mx-3">Применить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialog.pos_catalog.show"
      persistent
      max-width="80%"
    >
      <v-card>
        <v-card-title>Выберите номенклатуры</v-card-title>
        <v-card-text>
          <div>
            <v-data-table
              v-model="dialog.pos_catalog.data"
              :items-per-page="10"
              dense
              :items="select.nomenclature"
              :headers="[
                {value: 'name', text: 'Название'},
                {value: 'price', text: 'Цена'},
                {value: 'category', text: 'Категория'},
                {value: 'subcategory', text: 'Подкатегория'},
                {value: 'subsubcategory', text: 'Подподкатегория'},
              ]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              show-select
            >
              <template v-slot:item.category="{item}">
                <div>
                  <div v-if="item.category && dict.categories[item.category]">
                    {{ dict.categories[item.category] }}
                  </div>
                  <div v-else>
                    <span style="color: #EEEEEE">нет</span>
                  </div>
                </div>
              </template>
              <template v-slot:item.subcategory="{item}">
                <div>
                  <div v-if="item.subcategory && dict.categories[item.subcategory]">
                    {{ dict.categories[item.subcategory] }}
                  </div>
                  <div v-else>
                    <span style="color: #EEEEEE">нет</span>
                  </div>
                </div>
              </template>
              <template v-slot:item.subsubcategory="{item}">
                <div>
                  <div v-if="item.subsubcategory && dict.categories[item.subsubcategory]">
                    {{ dict.categories[item.subsubcategory] }}
                  </div>
                  <div v-else>
                    <span style="color: #EEEEEE">нет</span>
                  </div>
                </div>
              </template>
              <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <div
            class="mx-5"
            style="width: 100%"
          >
            <v-row class="justify-center">
              <v-col
                cols="6"
              >
                <v-btn
                  color="primary"
                  outlined
                  large
                  min-width="100"
                  @click="close_pos_catalog_dialog()"
                >
                  <span class="mx-3">Закрыть</span>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                class="d-flex justify-end"
              >
                <v-btn
                  color="primary"
                  large
                  min-width="200"
                  @click="add_pos_catalog_nomenclature()"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-textfield
      v-if="dialogTextFieldVisible"
      title="Наименование сценария"
      text="Введите наименование сценария"
      @cancel="dialogTextFieldVisible=false"
      @ok="onAddScenario"
    />
    <dialog-yes-no
      v-if="dialogYesNoVisible"
      title="Удаление сценария"
      text="Удалить сценарий?"
      @no="dialogYesNoVisible=false"
      @yes="dialogYesNo.actionYes"
    />
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { guid, isBlank } from "@/views/loyalty/shared/modules/utilities"
  import DialogTextfield from "@/views/loyalty/shared/components/dialog-textfield/DialogTextfield.vue"
  import DialogYesNo from "@/views/loyalty/shared/components/dialog-yesno/DialogYesNo.vue"
  import { JustpayPointService } from "@/views/loyalty/shared/services/justpay-point-service"
  import {
    ConfigurationPaymentMethodScreenTypeArray,
    ConfigurationFirstScreenTypeArray,
    ConfigurationTypeEnum
  } from "@/views/loyalty/models/justpay-configuration.model"
  import UploadMediaFiles from "@/views/admin/components/UploadMediaFiles.vue"
  import SetupFirstscreen from "@/views/loyalty/shared/components/justpay-configuration/SetupFirstscreen.vue"
  import { buttonExt, fifthScreen, fileMediaData, firstScreen, posPointBucketScreen, posPointChooseGoodsScreen, posPointChoosePaymentScreen } from "@/views/loyalty/models/justpay-configuration-interface.model"
  import { JustpayNomenclature } from "@/views/loyalty/shared/services/justpay-nomenclature-service"
  import SetupPaymentMethodScreen from "@/views/loyalty/shared/components/justpay-configuration/SetupPaymentMethodScreen.vue"
  import SetupUniversalScreen from "@/views/loyalty/shared/components/justpay-configuration/SetupUniversalScreen.vue"
  import SetupStaffScreen from "@/views/loyalty/shared/components/justpay-configuration/SetupStaffScreen.vue"
  import SetupStaffPaymentScreen
    from "@/views/loyalty/shared/components/justpay-configuration/SetupStaffPaymentScreen.vue"
  import SetupPospointBucketScreen from "@/views/loyalty/shared/components/justpay-configuration/SetupPosPointBucketScreen.vue"
  import SetupPospointChooseGoodsScreen from "@/views/loyalty/shared/components/justpay-configuration/SetupPosPointChooseGoodsScreen.vue"
  import SetupPospointChoosePaymentScreen from "@/views/loyalty/shared/components/justpay-configuration/SetupPosPointChoosePaymentScreen.vue"
  export default {
    components: { SetupPospointChoosePaymentScreen, SetupPospointChooseGoodsScreen, SetupPospointBucketScreen, SetupStaffPaymentScreen, SetupStaffScreen, SetupUniversalScreen, SetupPaymentMethodScreen, SetupFirstscreen, UploadMediaFiles, DialogYesNo, DialogTextfield },
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      dialog: {
        pos_catalog: {
          show: false,
          data: [],
          page: {}
        }
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      selected: {
      },
      form: {
        start_type: 0,
        service: {
          port: 14200,
          timeout: 60000,
          protocol: 0,
          send_to_server: true
        },
        type: 0,
        planogramm: [
          {
            new: true
          }
        ],
        settings: {
          server: `${process.env.VUE_APP_URL}`,
          port: 443
        },
        mdb: {
          enable: false
        },
        msb: {
          enable: false
        },
        sbp: {
          enable: false
        },
        common: {
          service_phone: '',
          fiscal_timeout: 5,
          fiscal_required: false,
          fiscal_card: true,
          fiscal_cash: true,
          repeatsRelay: false,
          inputCellCode: false,
          nomenclatureByDefault: '',
          useByDefault: false,
          firstScreenType: 1,
          paymentMethodScreenType: 2,
          cardTimeout: 150,
          sbpTimeout: 150,
          typeScreenMax: 0
        },
        bank_card: {
          enable: false,
          bank: 0
        },
        rele: {
          pages: []
        },
        pos: {
          pages: [],
          category_buttons: {
            text: {
              text: '',
              size: '20',
              color: '#FFFFFF'
            },
            background: '#345BBE',
            stroke: '#EA617B',
            radius: 0,
          },
          nomenclature_buttons: {
            text: {
              text: '',
              size: '14',
              color: '#FFFFFF'
            },
            background: '#345BBE',
            stroke: '#EA617B',
            radius: 0,
          },
          barcode_settings: {
            width: 800,
            height: 400,
            angle: 90
          },
          show_menu: false,
          show_second_screen: true,
          show_third_screen: true,
        },
        gas: {
          show_first_screen: true,
          fillingStopTimeout: 30
        },
        interface_description: {
          first_screen: {
            order: 0,
            background: '#D5D3DA',
            text1: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            },
            buttons_busy: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            },
            buttonsExt: [{ ...buttonExt }],
            audioData: fileMediaData,
          },
          second_screen: {
            order: 0,
            background: '#D5D3DA',
            text1: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            },
            buttons_busy: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            },
            toolbar: '#ffffff',
          },
          third_screen: {
            order: 0,
            background: '#D5D3DA',
            text1: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radiurs: 0,
            },
            buttons_busy: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            },
            buttons2: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            }
          },
          fourth_screen: {
            order: 0,
            background: '#D5D3DA',
            sum_full_tank: '0',
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0
            },
            show_full_tank: false
          },
          paymentMethodScreen: fifthScreen,
          universalScreen: fifthScreen,
          staffScreen: fifthScreen,
          staffPaymentScreen: fifthScreen,
          error_screen: {
            order: 0,
            background: '#D5D3DA',
            text1: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0,
            },
            buttons_busy: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF',
              radius: 0
            }
          },
          final_screen: {
            order: 0,
            background: '#D5D3DA',
            text1: {
              text: 'ПЛАТЕЖ ЗАВЕРШЕН',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text3: {
              text: 'Для получения чека - отсканируйте QR',
              size: '24',
              color: '#4C4E65'
            },
            show_qr: false
          }
        },
        releScenarios: [],
        jetinno: {
          ipAddressDevice: '',
          ipAddressServer: '',
          jetinnoScenarioPayment: 0
        },
        carWash: {
          enable: true,
          stepCost: 50,
          limitMinCost: 50,
          limitMaxCost: 500,
          carWashType: '',
          carWashBoxes: [
            { new: true }
          ],
          carWashPrices: [
            { new: true }
          ],
        },
        audioData: {
          timeout: 0,
          duration: 0,
          playEndless: false,
        },
        videoData1: {
          timeout: 0,
          duration: 0,
        },
        videoData2: {
          timeout: 0,
          duration: 0,
        },
        azs: { mode: 1 },
        posPointScreen: { posPointBucketScreen: posPointBucketScreen, posPointChooseGoodsScreen: posPointChooseGoodsScreen, posPointChoosePaymentScreen: posPointChoosePaymentScreen }
      },
      // end form
      select: {
        categories: [],
        categories_list: [],
        integration: [],
        integration_list: [],
        type: [
          { value: 0, text: 'Вендинг' },
          { value: 1, text: 'POS-терминал (прием платежей)' },
          { value: 2, text: 'Прием платежей' },
          { value: 3, text: 'Курьер' },
          { value: 4, text: 'Пожертвования' },
          { value: 5, text: 'Автомойки' },
          { value: 6, text: 'Витрина' },
          { value: 7, text: 'АЗС' },
          { value: 8, text: 'POS-точка' },
          { value: 9, text: 'Управление реле' },
          { value: 10, text: 'POS-точка с реле' },
          { value: 11, text: 'Яндекс Автозаправка' },
          { value: 12, text: 'СКУД' },
        ],
        state: [
          { value: 0, text: 'Активная' },
          { value: 1, text: 'Архивная' },
        ],
        tax: [
          { value: 1, text: 'НДС 20%' },
          { value: 2, text: 'НДС 10%' },
          { value: 3, text: 'НДС по расч. ставке 20/120' },
          { value: 4, text: 'НДС по расч. ставке 10/110' },
          { value: 5, text: 'НДС 0%' },
          { value: 6, text: 'НДС не облагается' },
          { value: 7, text: 'НДС 5%' },
          { value: 8, text: 'НДС 7%' },
          { value: 9, text: 'НДС по расч. ставке 5/105' },
          { value: 10, text: 'НДС по расч. ставке 7/107' },
          { value: 11, text: 'НДС 22%' },
          { value: 12, text: 'НДС по расч. ставке 22/122' },

        ],
        tax_kg: [
          { value: 0, text: 'НДС 0%' },
          { value: 1, text: 'НДС 12%' },
        ],
        nsp_kg: [
          { value: 0, text: 'НСП 0%' },
          { value: 1, text: 'НСП 1%' },
          { value: 2, text: 'НСП 2%' },
          { value: 3, text: 'НСП 3%' },
          { value: 4, text: 'НСП 5%' },
          { value: 5, text: 'НСП 0,5%' },
          { value: 6, text: 'НСП 1,5%' },
        ],
        equipment: [],
        equipmentsCatalog: [],
        nomenclature: [],
        nomenclature_type: [
          { value: 1, text: "Товар " },
          { value: 2, text: "Подакцизный товар " },
          { value: 3, text: "Работа " },
          { value: 4, text: "Услуга " },
          { value: 5, text: "Ставка азартной игры " },
          { value: 6, text: "Выигрыш азартной игры " },
          { value: 7, text: "Лотерейный билет " },
          { value: 8, text: "Выигрыш лотереи " },
          { value: 9, text: "Предоставление РИД " },
          { value: 10, text: "Платеж " },
          { value: 11, text: "Агентское вознаграждение " },
          { value: 12, text: "Выплата " },
          { value: 13, text: "Иной предмет расчета " },
          { value: 14, text: "Имущественное право " },
          { value: 15, text: "Внереализационный доход* " },
          { value: 16, text: "Иныеплатежи ивзносы* " },
          { value: 17, text: "Торговыйсбор " },
          { value: 18, text: "Курортныйсбор " },
          { value: 19, text: "Залог " },
          { value: 20, text: "Расход " },
          { value: 21, text: "Взносы наобязательноепенсионное страхование ИП " },
          { value: 22, text: "Взносы" }
        ],
        clients: [],
        scenarios: [],
        jetinno_jetinnoScenarioPayment_list: [
          { value: 1, text: 'Оплата на кофемашине' },
          { value: 2, text: 'Оплата на терминале' },
          { value: 3, text: 'Оплата на терминале и выдача товара на терминале' },
          { value: 4, text: 'Оплата на кофемашине и на терминале' },
        ],
        carWashBoxTypeList: [
          { value: 'SelfService', text: 'автомойка самообслуживания' },
          { value: 'Contactless', text: 'безконтактная' },
          { value: 'Manual', text: 'ручная мойка' },
          { value: 'Portal', text: 'портальная' },
          { value: 'Tunnel', text: 'тунельная' },
          { value: 'Dry', text: 'сухая' },
        ],
        carWashBoxStatusList: [
          { value: 'Free', text: 'свободен готов принимать заказы' },
          { value: 'Busy', text: 'занят' },
          { value: 'Unavailable', text: 'не доступен (закрыт на ремонте)' }
        ],
        carWashPriceTypeList: [
          { value: 'Fix', text: 'Фиксированная стоимость' },
          { value: 'PerMinute', text: 'Стоимость за минуту' },
        ]
      },
      // end select
      suggestion: {
        address: false
      },
      clients: [],
      dict: {
        device_type: {},
        device: {},
        categories: {},
        pos_page_types: [
          'Ввод данных',
          'Информация',
          'Каталог',
          'Корзина',
        ]
      },
       search: {
        client: {
          loading: false,
          text: ''
        },
        equipment: {
          loading: false,
          text: ''
        },
      },
      point: null,
      pointService: null,
      dialogTextFieldVisible: false,
      dialogTextfield: {
        textName: ''
      },
      dialogYesNoVisible: false,
      dialogYesNo: {
        title: '',
        text: '',
        actionYes: null,
      },
      descriptionTypes: [
        { text: 'Сумма', value: 1 },
        { text: 'Количество', value: 2 },
        { text: 'Описание', value: 3 },
      ],
      yandexCarwashBoxHeaders: [
        { text: 'Номер бокса', value: 'boxNumber' },
        // { text: 'Тип мойки', value: 'carWashBoxType' },
        { text: 'Статус', value: 'carWashBoxStatus' },
        { value: 'delete', text: '' }
      ],
      yandexCarwashPriceHeaders: [
        { text: 'Товар', value: 'nomenclature' },
        // { text: 'Описание', value: 'description' },
        { text: 'Цена', value: 'cost' },
        { text: 'Тип цены', value: 'costType' },
        { value: 'delete', text: '' }
      ],
      isAudioDataLoaded: false,
      isVideoData1Loaded: false,
      isVideoData2Loaded: false,
      isUsbConfLoaded: false,
      isWizarposLoaded: false,
      nomenclatureService: null,
    }),
    computed: {
      ConfigurationTypeEnum () {
        return ConfigurationTypeEnum
      },
      isKyrgyzClient () {
        const client = (this.select.clients || []).find(c => c.id === this.form.client)
        return !!client && client.country === 417
      },
      pos_nomenclature_headers () {
        const headers = [
          { sortable: false, value: 'delete', text: 'Убрать' },
          { value: 'code', text: 'Артикул' },
          { value: 'cellCode', text: 'Код ячейки' },
          { value: 'name', text: 'Название' },
          { text: 'Тип', value: 'type' },
          { text: 'Ставка НДС', value: 'tax' },
          { value: 'price', text: 'Цена' },
          { value: 'relayNumber', text: 'Серийный номер реле' },
          { value: 'scenario', text: 'Сценарий' },
          { value: 'equipment', text: 'Оборудование' },
          { value: 'category', text: 'Категория' },
          { value: 'subcategory', text: 'Подкатегория' },
          { value: 'subsubcategory', text: 'Подподкатегория' },
          { sortable: false, value: 'integration', text: 'Интеграция' },
          { value: 'next_on_choose', text: 'Переход на следующий шаг при выборе' }
        ]
        if (this.isKyrgyzClient) {
          headers.splice(headers.findIndex(h => h.value === 'tax') + 1, 0, { text: 'НСП', value: 'nsp_kg' })
        }
        return headers
      },
      planogramm_headers () {
        const result = [
          { text: 'Код ячейки', value: 'number' },
          { text: 'Реле', value: 'equipment' },
          { text: 'Сценарий', value: 'scenario' },
          { text: 'Тип описания', value: 'descriptionType' },
          { text: 'Описание', value: 'description' },
          { text: 'Тип', value: 'type' },
          { text: 'Товар', value: 'nomenclature' },
          { text: this.form.type == 6 || this.form.type == 9 || this.form.type === ConfigurationTypeEnum.Skud ? 'Количество' : 'Емкость ячейки', value: 'amount' },
          { text: 'Ставка НДС', value: 'tax' },
          { text: 'Стоимость (наличные)', value: 'price_cash' },
          { text: 'Стоимость (безналичные)', value: 'price_cashless' },
          { value: 'delete', text: '' }
        ]
        const headers_if_type_7 = [
          { text: 'Номер пистолета', value: 'number' },
          { text: 'Номер колонки', value: 'group_number' },
          { text: 'Тип', value: 'type' },
          { text: 'Товар', value: 'nomenclature' },
          { text: 'Емкость ячейки', value: 'amount' },
          { text: 'Ставка НДС', value: 'tax' },
          { text: 'Стоимость (наличные)', value: 'price_cash' },
          { text: 'Стоимость (безналичные)', value: 'price_cashless' },
          { value: 'delete', text: '' }
        ]
        if (this.isKyrgyzClient) {
          const nspHeader = { text: 'НСП', value: 'nsp_kg' }
          result.splice(result.findIndex(h => h.value === 'tax') + 1, 0, nspHeader)
          headers_if_type_7.splice(headers_if_type_7.findIndex(h => h.value === 'tax') + 1, 0, nspHeader)
        }
        return this.form.type == 7 ? headers_if_type_7 : result.filter(f => {
          if (this.form.type !== 9) {
            if (f.value !== 'equipment' && f.value !== 'scenario' && f.value !== 'descriptionType' && f.value !== 'description') {
              return f
            }
          } else return f
        })
      },

    },
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
    },
    beforeMount () {
      this.nomenclatureService = new JustpayNomenclature()
      this.pointService = new JustpayPointService()
      this.init()
    },
     mounted: async function () {
       var id = this.$route.query.id

      // this.load_equipments()
      // this.load_nomenclatures(this.form.client)
      for (const x in this.$store.state.dict.device_type) {
        this.dict.device_type[Number(x)] = this.$store.state.dict.device_type[x].name
      }
      // this.axios.post('/api/device/list', {})
      //   .then(result => {
      //       if (!result.data.error) {
      //         for (const x in result.data.data) {
      //           this.dict.device[result.data.data[x].id] = result.data.data[x].model
      //         }
      //       }
      //     })
      //     .catch(e => {
      //       console.log(e)
      //     })
      this.axios.post('/api/integration/list', {})
        .then(response => {
          if (!response.data.error) {
            this.select.integration = response.data.data
            this.select.integration_list = response.data.data.map(a => ({ value: a.id, text: a.description, type: a.type }))
          }
        })
      // this.load_clients()
      // this.load_categories()
      // this.load_nomenclature()
      const points = await this.pointService.getPoints({ configuration: id })
      this.point = points.data.find(point => point.configuration === id)
      console.log('this.point ', this.point)
      if (this.point) {
        this.select.equipments = this.point.equipments.map(equipment => {
          return {
            text: equipment.serial + " " + equipment.comment,
            value: equipment.id
          }
        })
        // for coffee machine
        this.select.equipmentsCatalog = this.point.equipments.filter(f => f.type === 5).map(equipment => {
          return {
            text: equipment.serial,
            value: equipment.id
          }
        })
      }
      if (this.form.type === 9) {
        this.descriptionTypes.push({ text: 'Код ячейки', value: 4 })
      }
    },
    methods: {
      ConfigurationPaymentMethodScreenTypeArray () {
        return ConfigurationPaymentMethodScreenTypeArray
      },
      ConfigurationFirstScreenTypeArray () {
        return ConfigurationFirstScreenTypeArray
      },
      init () {
        var id = this.$route.query.id
        if (id) {
          this.axios.post('/api/configuration/list', { id: id })
              .then(result => {
                if (!result.data.error) {
                  console.log('result.data.data', result.data.data)
                  console.log('result.data', result.data)
                  this.form = result.data.data[0]
                  if (this.form.updated) this.form.updated = moment(this.form.updated).format('YYYY-MM-DD')
                  this.form.planogramm = this.form.planogramm || []
                  this.form.planogramm.push({ new: true })
                  this.form.common = this.form.common || {}
                  this.form.bank_card = this.form.bank_card || {}
                  this.form.service = this.form.service || {
                    port: 14200,
                    timeout: 60000,
                    protocol: 0,
                    send_to_server: true
                  }
                  this.form.interface_description = this.form.interface_description || {
                    first_screen: {
                      order: 0,
                      background: '#D5D3DA',
                      text1: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      text2: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      buttons: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      buttons_busy: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      }
                    },
                    second_screen: {
                      order: 0,
                      background: '#D5D3DA',
                      text1: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      text2: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      buttons: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      buttons_busy: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      toolbar: '#ffffff'
                    },
                    third_screen: {
                      order: 0,
                      background: '#D5D3DA',
                      text1: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      text2: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      buttons: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      buttons_busy: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      buttons2: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      }
                    },
                    fourth_screen: {
                      order: 0,
                      background: '#D5D3DA',
                      sum_full_tank: '0',
                      buttons: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      show_full_tank: false
                    },
                    error_screen: {
                      order: 0,
                      background: '#D5D3DA',
                      text1: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      text2: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      buttons: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      },
                      buttons_busy: {
                        text: {
                          size: '20',
                          color: '#FFFFFF'
                        },
                        background: '#345BBE',
                        stroke: '#FFFFFF'
                      }
                    },
                    final_screen: {
                      order: 0,
                      background: '#D5D3DA',
                      text1: {
                        text: 'ПЛАТЕЖ ЗАВЕРШЕН',
                        size: '24',
                        color: '#4C4E65'
                      },
                      text2: {
                        text: '',
                        size: '24',
                        color: '#4C4E65'
                      },
                      text3: {
                        text: 'Для получения чека - отсканируйте данный QR-код.',
                        size: '24',
                        color: '#4C4E65'
                      },
                      show_qr: true
                    }
                  }
                  this.form.rele = this.form.rele || {}
                  this.form.rele.pages = this.form.rele.pages || []
                  this.form.pos = this.form.pos || { show_second_screen: true }
                  this.form.pos = this.form.pos || { show_third_screen: true }
                  this.form.gas = this.form.gas || { show_first_screen: true }
                  this.form.gas = this.form.gas || { fillingStopTimeout: 30 }

                  if (this.form.pos.pages && this.form.pos.pages.length > 0) {
                    for (const x in this.form.pos.pages) {
                      if (!this.form.pos.pages[x].open_price) {
                        this.form.pos.pages[x].open_price = {
                          enable: false,
                          name: "Свободная цена",
                          label: "Добавить Номенклатуру со свободной ценой"
                        }
                      }
                      if (!this.form.pos.pages[x].cart) {
                        this.form.pos.pages[x].cart = {
                          buttons: []
                        }
                      }
                      this.form.pos.pages[x].skip_codes = this.form.pos.pages[x].skip_codes || []
                    }
                  }
                  this.form.pos.pages = this.form.pos.pages || []
                  this.form.pos.category_buttons = this.form.pos.category_buttons || {
                    text: {
                      text: '',
                      size: '20',
                      color: '#FFFFFF'
                    },
                    background: '#345BBE',
                    stroke: '#EA617B'
                  }
                  this.form.pos.nomenclature_buttons = this.form.pos.nomenclature_buttons || {
                    text: {
                      text: '',
                      size: '14',
                      color: '#FFFFFF'
                    },
                    background: '#345BBE',
                    stroke: '#EA617B'
                  }
                  this.form.pos.barcode_settings = this.form.pos.barcode_settings || {
                    width: 800,
                    height: 400,
                    angle: 90
                  }
                  this.form.interface_description.first_screen = this.form.interface_description.first_screen || {
                    order: 0,
                    background: '#D5D3DA',
                    text1: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    text2: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    buttons: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    },
                    buttons_busy: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    }
                  }
                  this.form.interface_description.error_screen = this.form.interface_description.error_screen || {
                    background: '#D5D3DA',
                    text1: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    text2: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    buttons: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    }
                  }
                  this.form.interface_description.second_screen = this.form.interface_description.second_screen || {
                    background: '#D5D3DA',
                    text1: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    text2: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    buttons: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    },
                    buttons_busy: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    }
                  }
                  this.form.interface_description.third_screen = this.form.interface_description.third_screen || {
                    background: '#D5D3DA',
                    text1: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    text2: {
                      text: '',
                      size: '24',
                      color: '#4C4E65'
                    },
                    buttons: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    },
                    buttons_busy: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    },
                    buttons2: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    }
                  }
                  this.form.interface_description.fourth_screen = this.form.interface_description.fourth_screen || {
                    background: '#D5D3DA',
                    sum_full_tank: '0',
                    buttons: {
                      text: {
                        size: '20',
                        color: '#FFFFFF'
                      },
                      background: '#345BBE',
                      stroke: '#FFFFFF'
                    },
                    show_full_tank: false
                  }
                  this.form.interface_description.first_screen.buttons_busy = this.form.interface_description.first_screen.buttons_busy || {
                    text: {
                      size: '20',
                      color: '#FFFFFF'
                    },
                    background: '#345BBE',
                    stroke: '#FFFFFF'
                  }
                  this.form.interface_description.second_screen.buttons_busy = this.form.interface_description.second_screen.buttons_busy || {
                    text: {
                      size: '20',
                      color: '#FFFFFF'
                    },
                    background: '#345BBE',
                    stroke: '#FFFFFF'
                  }
                  this.form.interface_description.third_screen.buttons_busy = this.form.interface_description.third_screen.buttons_busy || {
                    text: {
                      size: '20',
                      color: '#FFFFFF'
                    },
                    background: '#345BBE',
                    stroke: '#FFFFFF'
                  }
                  this.form.interface_description.error_screen.buttons_busy = this.form.interface_description.error_screen.buttons_busy || {
                    text: {
                      size: '20',
                      color: '#FFFFFF'
                    },
                    background: '#345BBE',
                    stroke: '#FFFFFF'
                  }
                  if (this.form.client) {
                    this.load_clients_id(this.form.client)
                    this.load_nomenclatures(this.form.client)
                  }
                  if (this.form.type != 9 && this.form.type != 10 && this.form.type !== ConfigurationTypeEnum.Skud) {
                    this.form.releScenarios = []
                    this.form.releScenarios.push({ releConf: this.form.rele })
                  }
                  if (this.form.type == 9 || this.form.type == 10 || this.form.type === ConfigurationTypeEnum.Skud) {
                    this.form.releScenarios = this.form.releScenarios || []
                    this.select.scenarios = this.form.releScenarios.map(scenario => {
                      return {
                        text: scenario.scenarioName,
                        value: scenario.scenarioId
                      }
                    })
                  }
                  // jetinno
                  this.form.jetinno = this.form.jetinno || { ipAddressDevice: '', ipAddressServer: '', jetinnoScenarioPayment: 0 }
                  // YandexCarWash
                  if (this.form.type === ConfigurationTypeEnum.YandexCarWash) {
                    console.log('this.form,', this.form)
                    console.log('this.form.carWash,', this.form.carWash)
                    if (!this.form.carWash) {
                      this.form.carWash = {
                        enable: true,
                        stepCost: 50,
                        limitMinCost: 50,
                        limitMaxCost: 500,
                        carWashType: '',
                        carWashBoxes: [],
                        carWashPrices: []
                      }
                      this.form.carWash.carWashBoxes = this.form.carWash.carWashBoxes || []
                      this.form.carWash.carWashBoxes.push({ new: true })
                      this.form.carWash.carWashPrices = this.form.carWash.carWashPrices || []
                      this.form.carWash.carWashPrices.push({ new: true })
                      console.log('this.form.carWash,', this.form.carWash)
                    } else {
                      this.form.carWash.carWashBoxes.push({ new: true })
                      if (Object.hasOwn(this.form.carWash, 'carWashPrices')) {
                        if (this.form.carWash.carWashPrices) {
                          this.form.carWash.carWashPrices.push({ new: true })
                        } else {
                          this.form.carWash.carWashPrices = []
                          this.form.carWash.carWashPrices.push({ new: true })
                        }
                      } else {
                        Object.defineProperties(this.form.carWash, {
                          carWashPrices: {
                            value: [],
                            writable: true
                          }
                        })
                        this.form.carWash.carWashPrices.push({ new: true })
                        console.log('this.form.carWash.carWashPrices,', this.form.carWash.carWashPrices)
                      }
                    }
                  }
                  if (this.form.type === ConfigurationTypeEnum.Vending) {
                    if (!this.form.interface_description.first_screen.audioData) {
                      this.form.interface_description.first_screen.audioData = { timeout: 0, duration: 0, playEndless: false }
                    }
                    if (!this.form.interface_description.first_screen.videoData1) {
                      this.form.interface_description.first_screen.videoData1 = { timeout: 0, duration: 0 }
                    }
                    if (!this.form.interface_description.first_screen.videoData2) {
                      this.form.interface_description.first_screen.videoData2 = { timeout: 0, duration: 0 }
                    }
                    console.log('init this.form.interface_description.first_screen.audioData', this.form.interface_description.first_screen.audioData)
                    if (!this.form.interface_description.error_screen.audioData) {
                      this.form.interface_description.error_screen.audioData = { timeout: 0, duration: 0, playEndless: false }
                    }
                    if (!this.form.interface_description.final_screen.audioData) {
                      this.form.interface_description.final_screen.audioData = { timeout: 0, duration: 0, playEndless: false }
                    }
                    if (!this.form.usbConf) {
                      this.form.usbConf = { enable: false, port: 0 }
                    }
                    /// chooseGoodsScreen
                    if (!this.form.interface_description.chooseGoodsScreen) {
                      this.form.interface_description.chooseGoodsScreen = firstScreen
                    }
                    /// deliveryGoodsScreen
                    if (!this.form.interface_description.deliveryGoodsScreen) {
                      this.form.interface_description.deliveryGoodsScreen = firstScreen
                    }
                    this.isAudioDataLoaded = true
                    this.isVideoData1Loaded = true
                    this.isVideoData2Loaded = true
                    this.isUsbConfLoaded = true
                    this.isWizarposLoaded = true
                  }
                  if (this.form.type === ConfigurationTypeEnum.Donation || this.form.type === ConfigurationTypeEnum.Rele || this.form.type === ConfigurationTypeEnum.Vitrina || this.form.type === ConfigurationTypeEnum.Skud) {
                    if (!this.form.interface_description.first_screen.buttonsExt) {
                      this.form.interface_description.first_screen.buttonsExt = []
                      this.form.planogramm.forEach(p => {
                        if (p.number) {
                          this.form.interface_description.first_screen.buttonsExt.push({
                            cellCode: p.number,
                            background: "#ffffff",
                            label_type: 0,
                            text: { color: "#2970FF", size: 20 }
                          })
                        }
                      })
                    }
                  }
                  /// PaymentMethodScreen
                  if (this.form.type === ConfigurationTypeEnum.Vitrina) {
                    if (!this.form.interface_description.paymentMethodScreen) {
                      this.form.interface_description.paymentMethodScreen = fifthScreen
                    }
                    if (!this.form.interface_description.universalScreen) {
                      this.form.interface_description.universalScreen = fifthScreen
                    }
                    if (!this.form.interface_description.staffScreen) {
                      this.form.interface_description.staffScreen = fifthScreen
                    }
                    if (!this.form.interface_description.staffPaymentScreen) {
                      this.form.interface_description.staffPaymentScreen = fifthScreen
                    }
                  }
                  this.form.azs = this.form.azs || { mode: 1 }
                  if (this.form.type === ConfigurationTypeEnum.PosPoint || this.form.type === ConfigurationTypeEnum.PosPointRelay) {
                    if (!this.form.posPointScreen) {
                      this.form.posPointScreen = { posPointBucketScreen: posPointBucketScreen, posPointChooseGoodsScreen: posPointChooseGoodsScreen, posPointChoosePaymentScreen: posPointChoosePaymentScreen }
                    }
                  }
                }
                this.form.msb = this.form.msb || { enable: false }
              })
              .catch(e => {
                console.log(e)
              })
        }
      },
      skip_codes_save (page) {
        const new_values = page.temp_skip_codes.split(/[\s,]+/)

        new_values.forEach(new_value => {
          this.skip_codes_push(new_value, page)
        })

        page.temp_skip_codes = ''
      },
      skip_codes_push (value, page) {
        if (value && !page.skip_codes.includes(value)) {
          page.skip_codes.push(value)
          return true
        }
        return false
      },

      show_pos_catalog_dialog (page) {
        this.dialog.pos_catalog.page = page
        this.dialog.pos_catalog.data = []
        this.dialog.pos_catalog.show = true
      },
      close_pos_catalog_dialog () {
        this.dialog.pos_catalog.page = {}
        this.dialog.pos_catalog.data = []
        this.dialog.pos_catalog.show = false
      },
      add_pos_catalog_nomenclature () {
        const previously_selected_nomenclatures_id = this.dialog.pos_catalog.page.nomenclatures.map(a => a.id)
        this.dialog.pos_catalog.page.nomenclatures.push(
          ...this.dialog.pos_catalog.data.filter(
            a => (
              !previously_selected_nomenclatures_id.includes(a.id)
            )
          ).map(a => Object.assign({}, a))
        )

        this.dialog.pos_catalog.page = {}
        this.dialog.pos_catalog.data = []
        this.dialog.pos_catalog.show = false
      },
      delete_selected_nomenclatures (page) {
        const selected_nomenclatures_id = page.selected_nomenclature.map(a => a.id)
        page.nomenclatures = page.nomenclatures.filter(a => !selected_nomenclatures_id.includes(a.id))
        page.selected_nomenclature = []
      },
      delete_nomenclature (page, item, event) {
        // event.cancelBubble = true;
        page.nomenclatures = page.nomenclatures.filter(a => a.id != item.id)
      },
      /* add_nomenclature (item) {
        if (item.nomenclature_list && item.nomenclature_list.length > 0) {
          item.nomenclatures = [];
          item.nomenclatures.push(...this.select.nomenclature.filter(a => item.nomenclature_list.includes(a.id)))
        } else {
          item.nomenclatures = [];
          item.nomenclatures.push(...this.select.nomenclature.filter(
            a => (
              (item.category ? a.category == item.category : true) &&
              (item.subcategory ? a.subcategory == item.subcategory : true) &&
              (item.subsubcategory ? a.subsubcategory == item.subsubcategory : true)
            )
          ))
        }
      }, */
      add_new_pos_cart_button (page) {
        page.cart.buttons.push({
          background: "#E4E4E4",
          name: {
            size: 12,
            color: "#000000",
            text: "",
          },
          logo: null,
          logo_height: 0,
          logo_width: 0,
          logo_only: false,
          integration: null,
          scan: false
        })
      },
      add_new_pos_page () {
        this.form.pos.pages.push({
          type: null,
          field_name: '',
          action_type: null,
          integration: null,
          skip_codes: [],
          actions: [],
          category: null,
          subcategory: null,
          subsubcategory: null,
          nomenclature_list: [],
          selected_nomenclature: [],
          nomenclatures: [],
          open_price: {
            enable: false,
            name: 'Свободная цена',
            label: 'Добавить Номенклатуру со свободной ценой',
            tax: 6
          },
          screen: {
            background: '#D5D3DA',
            text1: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF'
            }
          },
          cart: {
            buttons: []
          }
        })
      },
      add_new_page: function (idx) {
        this.form.releScenarios[idx].releConf.pages.push({
          actions: [],
          screen: {
            background: '#D5D3DA',
            text1: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            text2: {
              text: '',
              size: '24',
              color: '#4C4E65'
            },
            buttons: {
              text: {
                size: '20',
                color: '#FFFFFF'
              },
              background: '#345BBE',
              stroke: '#FFFFFF'
            }
          }
        })
      },
      add_new_action: function (page) {
        page.actions.push({
          condition: {
            type: 0,
            value: 0,
            conditions: []
          },
          command: {

          }
        })
      },
      protocol_change: function () {
        if (this.form.service.protocol === 0) {
          this.form.service.port = 14200
        }
        if (this.form.service.protocol === 1) {
          this.form.service.port = 8888
        }
      },
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      // load_categories: function () {
      //   this.axios.post('/api/category/list', {
      //   })
      //   .then(result => {
      //     if (!result.data.error) {
      //       this.select.categories = result.data.data
      //       this.select.categories_list = result.data.data.filter(a => a.category == null).map(b => ({ value: b.id, text: b.name }))
      //       for (const x in result.data.data) {
      //         this.dict.categories[result.data.data[x].id] = result.data.data[x].name
      //       }
      //     }
      //   })
      //   .catch(e => {
      //     console.log(e)
      //   })
      // },
      // load_nomenclature: function () {
      //   this.axios.post('/api/nomenclature/list', {
      //   })
      //   .then(result => {
      //     if (!result.data.error) {
      //       this.select.nomenclature = result.data.data
      //     }
      //   })
      //   .catch(e => {
      //     console.log(e)
      //   })
      // },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      // equipment_selected: function () {
      //   if (this.form.equipment) {
      //     const equipment = this.select.equipment.filter(a => a.id == this.form.equipment)[0]
      //     if (equipment.planogramm) {
      //       this.form.planogramm = equipment.planogramm
      //       this.form.planogramm.push({ new: true })
      //     }
      //   }
      // },
      // load_equipments: function () {
      //   this.axios.post('/api/equipment/list', {})
      //   .then(result => {
      //       if (!result.data.error) {
      //         this.select.equipment = result.data.data
      //       }
      //     })
      //     .catch(e => {
      //       console.log(e)
      //     })
      // },
      nomenclature_selected: function (item) {
        if (item.nomenclature) {
          const nomenclature = this.select.nomenclature.filter(a => a.id == item.nomenclature)[0]
          item.tax = Number(nomenclature.tax)
          item.tax_kg = nomenclature.tax_kg
          item.nsp_kg = nomenclature.nsp_kg
          item.price_cashless = nomenclature.price
          item.price_cash = nomenclature.price
        }
      },
      load_nomenclatures: function (clientId) {
        console.log('load_nomenclatures clientId', clientId)
        this.axios.post('/api/nomenclature/list/all', { client: clientId })
        .then(result => {
            if (!result.data.error) {
              this.select.nomenclature = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      // equipment_filter: function (item, query, text) {
      //   if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      //   if (item.serial && item.serial.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      //   if (item.device && this.dict.device[item.device] && this.dict.device[item.device].toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      //   if (item.type && this.dict.device_type && this.dict.device_type[item.type].toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      //   return false
      // },
      nomenclature_filter: function (item, query, text) {
        if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.name && item.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.description && item.description.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.code && item.code.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      planogramm_change: function (item) {
        if (item.new) {
          item.new = false
          this.form.planogramm.push({
            new: true
          })
        }
        if (this.form.type === ConfigurationTypeEnum.Donation || this.form.type === ConfigurationTypeEnum.Rele || this.form.type === ConfigurationTypeEnum.Vitrina || this.form.type === ConfigurationTypeEnum.Skud) {
          const foundItem = this.form.interface_description.first_screen.buttonsExt.find(f => f.cellCode == item.number)
          // console.log('planogramm_change foundItem', foundItem)
          // console.log('planogramm_change item', item)
          // console.log('planogramm_change item.number', item.number)
          // if foundItem is empty it is unique
          if (!foundItem && item.number) {
            // console.log('item.number is unique')
            this.form.interface_description.first_screen.buttonsExt.push({
              cellCode: item.number,
              background: "#ffffff",
              label_type: 0,
              text: { color: "#2970FF", size: 20 }
            })
          }
          // to delete not existed items
          this.form.interface_description.first_screen.buttonsExt = this.form.interface_description.first_screen.buttonsExt.filter(f => {
            const foundCellCode = this.form.planogramm.find(p => p.number == f.cellCode)
            if (foundCellCode) { return true } else { return false }
          })
        }
      },
      save: function (save) {
        let url = '/api/configuration/create'
        if (this.form.id) { url = '/api/configuration/save' }
        if (this.form.type != 9 && this.form.type != 10 && this.form.type !== ConfigurationTypeEnum.Skud) {
          this.form.releScenarios = null
        }
        this.form.planogramm = this.form.planogramm.filter(a => !a.new || a.new == false)
        if (this.form.type === ConfigurationTypeEnum.YandexCarWash) {
          this.form.carWash.carWashBoxes = this.form.carWash.carWashBoxes.filter(a => !a.new || a.new == false)
          this.form.carWash.carWashPrices = this.form.carWash.carWashPrices.filter(a => !a.new || a.new == false)
        }
        const request_data = Object.assign({}, this.form)
        request_data.pos.pages.forEach(element => {
          delete element.nomenclature_list
          delete element.selected_nomenclature
        })
        this.axios.post(url, this.form)
          .then(result => {
            if (!result.data.error) {
              this.form.planogramm.push({
                new: true
              })
              this.$store.commit('snackbar', 'Данные успешно сохранены')
              if (save) {
                this.$router.go(-1)
              }
            } else {
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
      },
      onAddScenario (textName) {
        console.log('onAddScenario textName', textName)
        console.log('onAddScenario this.form', this.form)
        const scenarioId = guid()
        if (isBlank(textName)) {
          textName = scenarioId
        }
        this.form.releScenarios.push({ scenarioId: scenarioId, scenarioName: textName, releConf: { pages: [] } })
        this.select.scenarios = this.form.releScenarios.map(scenario => {
          return { text: scenario.scenarioName, value: scenario.scenarioId }
        })
        this.dialogTextFieldVisible = false
      },
      onCarWashBoxAdd (item) {
        if (item.new) {
          item.new = false
          this.form.carWash.carWashBoxes.push({
            new: true
          })
        }
      },
      onCarWashPriceAdd (item) {
        console.log('onCarWashPriceAdd is fired!')
        console.log('onCarWashPriceAdd item', item)
        if (item.new) {
          item.new = false
          this.form.carWash.carWashPrices.push({
            new: true
          })
        }
        console.log('onCarWashPriceAdd this.form.carWash.carWashPrices', this.form.carWash.carWashPrices)
      },
      onCarWashNomenclatureSelect (item) {
        if (item.nomenclature) {
          const nomenclature = this.select.nomenclature.filter(a => a.id == item.nomenclature)[0]
          // item.tax = Number(nomenclature.tax)
          // item.price_cashless = nomenclature.price
          item.cost = nomenclature.price
          item.description = nomenclature.name
        }
      },
      onCopyScenario (idx) {
        console.log('idx=', idx)
        const copiedScenario = JSON.parse(JSON.stringify(this.form.releScenarios[idx]))
        copiedScenario.scenarioId = guid()
        copiedScenario.scenarioName = `Копия ${copiedScenario.scenarioName}`
        console.log('copiedScenario', copiedScenario)
        this.form.releScenarios.push(copiedScenario)
      },
      onDeleteButtonExt (item) {
        if (this.form.type === ConfigurationTypeEnum.Donation || this.form.type === ConfigurationTypeEnum.Rele || this.form.type === ConfigurationTypeEnum.Vitrina || this.form.type === ConfigurationTypeEnum.Skud) {
          this.form.interface_description.first_screen.buttonsExt = this.form.interface_description.first_screen.buttonsExt.filter(f => f.cellCode != item.number)
        }
      },
      onDeleteScenario (idx) {
        this.form.releScenarios.splice(idx, 1)
        this.dialogYesNoVisible = false
      },
      onDialogScenario () {
        this.dialogTextFieldVisible = true
      },
      onDialogYesNoForDeletingScenario (idx) {
        this.dialogYesNoVisible = true
        this.dialogYesNo.actionYes = this.onDeleteScenario.bind(this, idx)
      },
      onMouseOver (event) {
        event.target.style.color = "#0277BD"
      },
      onMouseOut (event) {
        event.target.style.color = "#B3E5FC"
      }

    },
  }
</script>
<style>
.btn-new-scenario {
  color: #B3E5FC;
}
.btn-new-scenario:hover {
  color: #0277BD;
}
</style>
